import React, { Component } from "react";
import { createPortal } from "react-dom";
import { formatChapterName } from '../../../utils/formatChapterName';
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import { sendPaymentForm_action } from "../../../actions/payment_action/payment_action";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import { BASE_URL, attendeeTypeActionId, cityActionId, countryActionId, exhibitorBadgeDaysActionId, industryChaptersActionId, paymentPortalLink, pincodeActionId, primaryChapterListActionId, seminarInterestActionId, stateActionId, exhibitionStatusActionId, B2BTimeslotActionID, toastError, toastSuccess, visitPurposeActionId, visitorInterestActionId, visitorTypeListActionId, genderActionId, paymentMasterListActionId, surchargeListActionId, companyTurnOverActionId, countryIWithCodeActionId, GSTvalidationActionId } from "../../../utils/constants";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo"
import { getExhNoteDetails_action } from "../../../actions/admin_module_action/master_action/exhibition_master_action/exh_note_action"
import { fill_action } from "../../../actions/fillCombo_action"
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import DatePicker from "react-datepicker";
import Resizer from "react-image-file-resizer";
import { data } from "jquery";
import { combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action, deleteVisaDoc_action } from "../../../actions/visitor_module_action/visitor_form_action/visitor_form_action"
import { emailValidator } from "../../../utils/Validator";
import Modal from "react-modal";
import { Tab, Nav, ToggleButton, ButtonGroup, Container, Row, Stack } from "react-bootstrap";
import { getVisitorRegistrationCredentials_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action";
import { payment_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action"
import { getVisitorPreviewDetails_action, visitorPreviewSubmit_action } from "../../../actions/visitor_module_action/visitor_registration_action/visitor_registration_action";
import { getDelegatePreviewDetails_action, delegatePreviewSubmit_action, getDelegateFirldList_action } from "../../../actions/delegate_module_action/delegate_registration_action/delegate_registration_action";
import VisitorHeader from "../../../common_components/visitor_module_header";
import moment from "moment";
import { getExhibitionProgramMaster_action } from "../../../actions/admin_module_action/delegate_master_action/delegate_program_action"


class Delegate_Preview extends Component {

    // Initialize Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isOpen4: false,
            isLoading: false,
            isOpen: false,
            GroupDetailsList: [],
            agreeTerms: false,
            showFieldList: [],
            primaryChapterListData: [],
            level0: [],
            level2: [],
            level3: [],
            level4: [],
            countryList: [],
            stateList: [],
            turnOverList: [],
            cityList: [],
            seminarList: [],
            pincodeList: [],
            genderList: [],
            gstValidtionList: [],
            chapterList: [],
            visitorTypeList: [],
            visitPurposeList: [],
            interestList: [],
            daysList: [],
            note: [],
            B2bMeetingList: [],
            delegateCharges: '',
            paymentDatesList: [],
            totalCharges: '',
            toShow: '',
            additionalChargesUSD: '',
            conversionRate: '',
            additionalChargesUSDper: '',
            pgViewChargesModal: false,
            pgViewAddChargesModal: false,
            pgViewChargesFillList: [],
            isSurchargeForceOpen: true,
            isForeignDelegatePop: false,
            isPaidByUSD: true,
            scripts: [],
            programList: [],
            isPaymentEnable: false
        }
        this.submitfrm = React.createRef()
        this.getDelegateRegistrationDetails = this.getDelegateRegistrationDetails.bind(this)
        this.renderGroupList = this.renderGroupList.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.getNotes = this.getNotes.bind(this)
        this.navToPayment = this.navToPayment.bind(this)
        this.onPrevClick = this.onPrevClick.bind(this)
    }

    async callGAScripts() {
        const { scripts } = this.state
        const script1 = document.createElement("script");
        script1.async = true;
        script1.src = "https://www.googletagmanager.com/gtag/js?id=G-1QY8MXN64V";
        document.head.appendChild(script1);
        scripts.push(script1); // Store reference

        const script2 = document.createElement("script");
        script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-1QY8MXN64V');
    `;
        document.head.appendChild(script2);
        scripts.push(script2)
    }

    componentWillUnmount() {
        // Cleanup: Remove scripts when component unmounts
        const { scripts } = this.state
        if (scripts) {
            scripts.forEach((script) => {
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
            });
        }
    }

    componentDidMount() {
        // getting Exhibition Code from Url
        // var exhCode = ""
        // if (this.props.location != null && this.props.location.state == null) {
        //     var url = this.props.location.pathname != null && this.props.location.pathname.split("/")
        //     exhCode = url[url.length - 1]
        //     if (exhCode != '') {
        //         this.setState({ AccountTypeID: 10, DelegateTypeID: 2 })
        //     }
        // sessionStorage.setItem("sessionExhibitionID", exhCode)visitorInterestActionId
        // console.log("h7hyhyhh", this.props.location.state, 'this.props.location.state', exhCode)
        // this.getFillList(countryIWithCodeActionId, '', '', '', exhCode, '').then(res => {
        //exhibition status.................
        this.callGAScripts()
        // window.location.reload()
        window.scrollTo(0, 0)
        if (sessionStorage.getItem('RoleIDSS')) {
            console.log(sessionStorage.getItem('sessionExhibitionID'), 'sessionStorage.getItem()')
            this.getExhibitionProgramMaster(sessionStorage.getItem('sessionExhibitionID'))
        }
        this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
            this.getFillList(paymentMasterListActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                    this.getFillList(visitorInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                        this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

                            this.getFillList(B2BTimeslotActionID, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

                                this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                    this.getFillList(genderActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

                                        this.getFillList(seminarInterestActionId, sessionStorage.getItem('sessionExhibitionID'), '', 3, '', '').then(() => {
                                            this.getFillList(companyTurnOverActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                this.getFillList(visitPurposeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                    this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                        //     this.getFillList(attendeeTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
                                                        //         this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                        this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                            this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                this.getFillList(surchargeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => { })
                                                                //                     this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
                                                                //                         this.setState({ isLoading: false })
                                                                //                     })
                                                                //                 })
                                                                // var Arr = sessionStorage.getItem('showFieldList').split(',').map(Number)
                                                                // this.setState({ showFieldList: Arr })
                                                                this.getFieldList(sessionStorage.getItem('DelegateTypeID'))
                                                                this.getDelegateRegistrationDetails()
                                                                this.getNotes()
                                                            })
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
            // })
        }).catch(err => {
            console.log(err)
        })
        // })
        // }
        // else if (this.props.location.state != null && this.props.location.state.is_previous) {
        //     //exhibition status..................
        //     this.getFillList(exhibitionStatusActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

        //         // Country List 
        //         this.getFillList(countryActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
        // this.getFillList(GSTvalidationActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {

        // this.getFillList(genderActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
        //             this.getFillList(attendeeTypeActionId, sessionStorage.getItem('sessionExhibitionID'), '', '', '', '').then(() => {
        //                 this.getFillList(exhibitorBadgeDaysActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
        //                     this.getFillList(visitorTypeListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
        //                         this.getFillList(industryChaptersActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
        //                             this.getFillList(primaryChapterListActionId, sessionStorage.getItem('sessionExhibitionID'), "", "", "", "").then(() => {
        //                                 this.getRegistrationDetails()
        //                             })
        //                         })
        //                     })
        //                 })
        //                 })
        //                 })
        //             })
        //         })
        //     })
        //     // Attendee List
        //     // Days List Action

        // }
        setTimeout(() => {
            if (sessionStorage.getItem('promoCode') != null && sessionStorage.getItem('promoCode') != '') {
                this.setState({
                    promoCode: sessionStorage.getItem('promoCode'),
                    isPromoApply: true
                })
            }
        }, 500);

        if (this.props.params != null && (this.props.params.status == "Failure" || this.props.params.status == "Invalid")) {
            toast.error('There is some problem. Please try again later!', {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })
        }

    }

    getExhibitionProgramMaster(exhCode) {
        this.setState({ isLoading: true });
        return new Promise((resolve, reject) => {
            console.log(exhCode, 'chapterIDArr')
            this.props
                .getExhibitionProgramMaster_action(exhCode)
                .then((data) => {
                    console.log(exhCode, 'chapterIDArr2')
                    if (data.error != 1 && data.data != null && data.data.length > 0) {
                        const [programs, dates, categories] = data.data;
                        programs.map((program, index) => {
                            var temppath = program.InvitationCard
                            var temparr = temppath != null &&
                                temppath != "" ? temppath.split("/") : []
                            var tempName = temparr.length > 0 ? temparr[temparr.length - 1] : ''
                            program.DocumentName = temppath != '' && temppath != null ? tempName : ''
                            // data.data[0][0].DocumentType = ''
                            // data.data[0][0].DocumentFile = ''
                            program.DocumentPath = temppath != '' && temppath != null ? temppath : ''
                            // setTimeout(() => {

                        })
                        setTimeout(() => {
                            const result = dates.map((date, index) => {
                                const program = programs.find(
                                    program => program.ExhProgramID === date.ExhProgramID
                                );

                                const firstIndex = dates.findIndex(
                                    item => item.ExhProgramID === date.ExhProgramID
                                );

                                const rowspan = dates.filter(
                                    item => item.ExhProgramID === date.ExhProgramID
                                ).length;

                                const dateCategories = categories
                                    .filter(
                                        category =>
                                            category.ExhProgramDateID === date.ExhProgramDateID
                                    )
                                    .map(category => ({
                                        ...category,
                                        isSelect: false
                                    }));
                                console.log(program, 'programprogram')
                                return {
                                    ExhProgramID: program.ExhProgramID,
                                    ExhibitionID: program.ExhibitionID,
                                    ProgramName: program.ProgramName,
                                    Location: program.Location,
                                    IsActive: program.IsActive,
                                    DocumentName: program.DocumentName,
                                    DocumentPath: program.DocumentPath,
                                    isSelect: false,
                                    toShow: index === firstIndex,
                                    rowspan,

                                    ExhProgramDateID: date.ExhProgramDateID,

                                    // Date → 17/08/2026
                                    Date: moment(date.Date).format("DD/MM/YYYY"),

                                    Days: date.Days,

                                    // Time → 10:00
                                    StartTime: moment(date.StartTime).format("HH:mm"),
                                    EndTime: moment(date.EndTime).format("HH:mm"),

                                    catogary: dateCategories
                                };
                            });

                            console.log('resultresultresult', result)
                            this.setState({ programList: result });
                        }, 100);

                        resolve(true)
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                })
                .catch((e) => {
                    window.location.reload()
                    console.log(e);
                });
        })
    }

    getNotes() {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList,
            daysList, daysListModal, B2bMeetingListmodal,
            B2bMeetingList, note } = this.state
        // this.setState({ isLoading: true })
        this.props.getExhNoteDetails_action(sessionStorage.getItem('sessionExhibitionID'))
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    var notesArr = []
                    data.data.length > 0 && data.data.map(item => {
                        if (item.NoteType == 'Delegate Registration') {
                            notesArr.push(item.Description)
                        }
                    })
                    this.setState({ note: notesArr })
                }
            })
    }

    // Get Visitor Registration Details
    getDelegateRegistrationDetails() {
        setTimeout(() => {
            const { attendeeList, programList, industryChapterList, GroupDetailsList, primaryChapterListData,
                level2, level3, level4, seminarList, countryList,
                stateList, turnOverList,
                cityList,
                pincodeList,
                genderList,
                gstValidtionList,
                chapterList,
                visitorTypeList,
                visitPurposeList,
                interestList,
                daysList,
                B2bMeetingList } = this.state
            this.setState({ isLoading: true })
            this.props.getDelegatePreviewDetails_action(sessionStorage.getItem('DelegateTypeID'))
                .then((data) => {
                    if (data.error != 1) {
                        console.log(data.data[0])
                        // if (data.data[0].length > 1) {
                        data.data[0].map((item, i) => {
                            var daysArr = []
                            var selectedDaysList = data.data[1] != null ? data.data[1] : []
                            console.log('daysArrdaysArrdaysArrdaysArrdaysArr', daysList, selectedDaysList)
                            daysList.length > 0 && daysList.map((element) => {
                                selectedDaysList.length > 0 && selectedDaysList.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (moment(element2.VisitDate).format('DD MMM YYYY') == element.VisitDate) {
                                            element.isSelect = true
                                            daysArr.push(element)
                                        }
                                    }
                                })
                            })
                            var chapterListSelected = []
                            var selectedChapters = data.data[2] != null ? data.data[2] : []
                            chapterList.length > 0 && chapterList.map((element) => {
                                selectedChapters.length > 0 && selectedChapters.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.IndustrySegmentID == element.IndustrySegmentID) {
                                            element.isSelect = true
                                            chapterListSelected.push(element)
                                        }
                                    }
                                })
                            })

                            var purposeOfVisit = []
                            var selectedPurposeOfVisit = data.data[4] != null ? data.data[4] : []
                            visitPurposeList.length > 0 && visitPurposeList.map((element) => {
                                selectedPurposeOfVisit.length > 0 && selectedPurposeOfVisit.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.PurposeofVisitID == element.PurposeofVisitID) {
                                            element.IsSelect = true
                                            purposeOfVisit.push(element)
                                        }
                                    }
                                })
                            })
                            console.log("purposeOfVisitpurposeOfVisit", purposeOfVisit)

                            var hallList = []
                            var SelectedHallChapters = data.data[3] != null ? data.data[3] : []
                            primaryChapterListData.length > 0 && primaryChapterListData.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            element.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level2.length > 0 && level2.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            element.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level3.length > 0 && level3.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            element.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })
                            level4.length > 0 && level4.map((element) => {
                                SelectedHallChapters.length > 0 && SelectedHallChapters.map((element2) => {
                                    if (element2.MappingDelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.MappingChapterID == element.ChapterID) {
                                            element.IsSelect = true
                                            hallList.push(element)
                                        }
                                    }
                                })
                            })


                            var seminarListSelected = []
                            var selectedseminarList = data.data[5] != null ? data.data[5] : []
                            console.log(selectedseminarList, 'selectedDaysList', seminarList)

                            seminarList.length > 0 && seminarList.map((element) => {
                                selectedseminarList.length > 0 && selectedseminarList.map((element2) => {
                                    if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                        if (element2.SeminarID == element.SeminarID) {
                                            element.isSelect = true
                                            seminarListSelected.push(element)
                                        }
                                    }
                                })
                            })

                            var B2bListSelected = []
                            var selectedB2bList = data.data[6] != null ? data.data[6] : []
                            B2bMeetingList.length > 0 && B2bMeetingList.map((element) => {
                                var B2bTimeSlotList = []
                                element.timeSlotList.length > 0 && element.timeSlotList.map((inElement) => {
                                    console.log(B2bListSelected, '===++')
                                    selectedB2bList.length > 0 && selectedB2bList.map((element2) => {
                                        if (element2.DelegateRegistrationID == item.DelegateRegistrationID) {
                                            if (element2.B2BTimeSlotID == inElement.B2BTimeSlotID) {
                                                console.log(element2.DelegateRegistrationID, item.DelegateRegistrationID)
                                                console.log(element2.B2BTimeSlotID, inElement.B2BTimeSlotID)
                                                inElement.isSelect = true
                                                // B2bListSelected.push(element)
                                                B2bTimeSlotList.push(inElement)
                                            }
                                        }
                                    })
                                })
                                if (B2bTimeSlotList.length != 0) {
                                    var b2bObj = {
                                        'date': element.date,
                                        'timeSlotList': B2bTimeSlotList
                                    }
                                    B2bListSelected.push(b2bObj)
                                }
                            })
                            console.log(B2bListSelected, 'IsIntrestedForB2B')



                            var mob1 = item['MobileNo']
                            const parts = mob1 != '' && mob1 != null ? mob1.split("-") : [];
                            const Mob1Code = parts.length == 2 ? parts[0] : ''
                            const Mob1No = parts.length == 2 ? parts[1] : mob1
                            // WhatsApp Mobile No
                            var mob2 = item['WhatsappMobileNo']
                            const parts2 = mob2 != '' && mob2 != null ? mob2.split("-") : []
                            const Mob2Code = parts2.length == 2 ? parts2[0] : ''
                            const Mob2No = parts2.length == 2 ? parts2[1] : mob2
                            var mob5 = item['ApplicantMobileNo']
                            const parts5 = mob5 != '' && mob5 != null ? mob5.split("-") : []
                            const Mob5Code = parts5.length == 2 ? parts5[0] : ''
                            const Mob5No = parts5.length == 2 ? parts5[1] : mob5
                            // TelePhone No
                            var tel = item['Telephone']
                            const parts3 = tel != '' && tel != null ? tel.split("-") : []
                            const telCode = parts3.length == 2 ? parts3[0] : ''
                            const telNumber = parts3.length == 2 ? parts3[1] : tel
                            // Telephone 1 Mobile No
                            var tel1 = item['Telephone1']
                            const parts4 = tel1 != '' && tel1 != null ? tel1.split("-") : []
                            const tel1Code = parts4.length == 2 ? parts4[0] : ''
                            const tel1Number = parts4.length == 2 ? parts4[1] : tel1
                            var filePath = item.PassportFilePath != null ? item['PassportFilePath'] : ''
                            var array = item['PassportFilePath'] != null && item['PassportFilePath'] != "" && filePath.split("/")
                            const FileName = array[array.length - 1]
                            var obj = {
                                'DelegateRegistrationID': item.DelegateRegistrationID ? item.DelegateRegistrationID : '',
                                'AccountTypeName': item.AccountTypeName ? item.AccountTypeName?.split(' ')[0] : '',
                                'AccountTypeID': item.AccountTypeID ? item.AccountTypeID : '',
                                'AccountID': item.AccountID ? item.AccountID : '',
                                'DelegateRegistrationNo': item.DelegateRegistrationNo ? item.DelegateRegistrationNo : '',
                                'Title': item.PersonIncharge_Title ? item.PersonIncharge_Title : '',
                                'firstName': item.PersonIncharge_FirstName ? item.PersonIncharge_FirstName : '',
                                'lastName': item.PersonIncharge_LastName ? item.PersonIncharge_LastName : '',
                                'gender': item.PersonIncharge_GenderID ? item.PersonIncharge_GenderID : '',
                                'designation': item.PersonIncharge_Designation ? item.PersonIncharge_Designation : '',
                                'CompanyName': item.CompanyName ? item.CompanyName : '',
                                'GSTNo': item.GSTNo ? item.GSTNo : '',
                                'PanNo': item.PanNo ? item.PanNo : '',
                                'IECCode': item.IECCode ? item.IECCode : '',
                                'Address1': item.Address1 ? item.Address1 : '',
                                'Address2': item.Address2 ? item.Address2 : '',
                                'Address3': item.Address3 ? item.Address3 : '',
                                'City': item.City ? item.City : '',
                                'State': item.State ? item.State : '',
                                'Pin': item.Pin ? item.Pin : '',
                                'PrimaryEmail': item.PrimaryEmail ? item.PrimaryEmail : '',
                                'Website': item.Website ? item.Website : '',
                                'Telephone': telNumber ? telCode ? `${telCode}-${telNumber}` : telNumber : '',
                                'Telephone1': tel1Number ? tel1Code ? `${tel1Code}-${tel1Number}` : tel1Number : '',
                                'CountryID': item.CountryID ? item.CountryID : '',
                                'CountryName': item.CountryNmae ? item.CountryNmae : '',
                                'mobNo': Mob1No ? Mob1Code ? `${Mob1Code}-${Mob1No}` : Mob1No : '',
                                'whatsAppMobNo': Mob2No ? Mob2Code ? `${Mob2Code}-${Mob2No}` : Mob2No : '',
                                'IsIntrestedForB2B': item.IsIntrestedForB2B,
                                'CompanyProfile': item.CompanyProfile ? item.CompanyProfile : '',
                                'CompanyWebsite': item.CompanyWebsite ? item.CompanyWebsite : '',
                                'TotalOperationalYears': item.TotalOperationalYears ? item.TotalOperationalYears : '',
                                'CompanyTurnOverID': item.CompanyTurnOverID ? item.CompanyTurnOverID : '',
                                'CompanyTurnOver': item.CompanyTurnOver ? item.CompanyTurnOver : '',
                                'PersonProfile': item.PersonProfile ? item.PersonProfile : '',
                                'ArrivalDate': item.ArrivalDate ? new Date(item.ArrivalDate) : '',
                                'DepartureDate': item.DepartureDate ? new Date(item.DepartureDate) : '',
                                'IsCoordinator': item.IsCoordinator ? item.IsCoordinator : '',
                                'isCoordinatorAsDelegate': item.isCoordinatorAsDelegate ? item.isCoordinatorAsDelegate : '',
                                'chaptersList': hallList,
                                'seminarList': seminarListSelected,
                                'visitdays': daysArr,
                                'purposeOfVisitList': purposeOfVisit,
                                'industrySegmentList': chapterListSelected,
                                'B2BmappingList': B2bListSelected,
                                'ApplicantEmailID': item.ApplicantEmailID ? item.ApplicantEmailID : '',
                                'PreApplicantMobileNo': Mob5Code,
                                'ApplicantMobileNo': Mob5No,
                                'NameOnPassport': item.NameOnPassport ? item.NameOnPassport : '',
                                'PassportExpiryDate': item.PassportExpiryDate ? new Date(item.PassportExpiryDate) : '',
                                'PassportFile': item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                'passportFileName': item.PassportFilePath != null && item.PassportFilePath != '' ? FileName : '',
                                'passportFilePath': item.PassportFilePath ? item.PassportFilePath : '',
                                'PersonPhoto': item.PersonPhoto ? item.PersonPhoto : '',
                                'PassportFileType': '',
                                'PassportIssueDate': item.PassportIssueDate ? new Date(item.PassportIssueDate) : '',
                                'PassportIssuingCountryID': item.PassportIssuingCountryID ? item.PassportIssuingCountryID : '',
                                'PassportIssuingCountryID': item.PassportIssuingCountryID ? item.PassportIssuingCountryID : '',
                                'PassportNo': item.PassportNo ? item.PassportNo : '',
                                'isVisaAssistance': item.isVisaAssistance ? item.isVisaAssistance : '',
                                'isSameAsMobNo': item.IsSameMobileNo ? item.IsSameMobileNo : '',
                                'isPassportFilePresent': item.PassportFilePath != null && item.PassportFilePath != '' ? true : false,
                                'isVisaApplied': item.PassportFilePath != null && item.PassportFilePath != '' ? true : false
                            }
                            this.state.GroupDetailsList.push(obj)
                        })
                        if (
                            data.data[7].length > 0
                        ) {
                            for (var i = 0; i < data.data[7].length; i++) {
                                if (data.data[7][i].TotalAmt != undefined) {
                                    if (data.data[7][i].Narration.trim() == 'CGST') {
                                        this.setState({
                                            CGST: data.data[7][i].TotalAmt
                                        })
                                    }
                                    if (data.data[7][i].Narration.trim() == "Delegate Registration Charges") {
                                        this.setState({
                                            delegateCharges: data.data[7][i].TotalAmt
                                        })
                                    }
                                    if (data.data[7][i].Narration.trim() == 'Total Taxable') {
                                        this.setState({
                                            totaltaxable: data.data[7][i].TotalAmt
                                        })
                                    }
                                    if (data.data[7][i].Narration.trim() == 'Grand Total') {
                                        // console.log(((data.data['registrationDetails'][0].additionalChargesUSD / 100) * data.data[7][i].TotalAmt).toFixed(2), 'opoppo')
                                        this.setState({
                                            totalCharges: data.data[7][i].TotalAmt,
                                            toShow: data.data[7][i].TotalAmt,
                                            additionalChargesUSD: ((data.data[0][0].additionalChargesUSD / 100) * data.data[7][i].TotalAmt).toFixed(2)
                                        })
                                        sessionStorage.setItem('grandtotal', data.data[7][i].TotalAmt)
                                    }
                                    if (data.data[7][i].Narration.trim() == 'SGST') {
                                        this.setState({
                                            SGST: data.data[7][i].TotalAmt
                                        })
                                    }
                                    if (data.data[7][i].Narration.trim() == 'IGST') {
                                        this.setState({
                                            IGST: data.data[7][i].TotalAmt
                                        })
                                    }
                                    if (data.data[7][i].Narration.trim() == 'Discount') {
                                        this.setState({
                                            promoCodeDiscount: data.data[7][i].TotalAmt
                                        })
                                    }
                                }
                            }
                        }
                        if (programList.length > 0) {
                            var ExhProgramArr = []
                            var ExhProgramDateArr = []
                            var ExhProgramCategoryArr = []
                            programList.map(main => {
                                data.data[11].map(item => {
                                    if (main.ExhProgramDateID == item.ExhProgramDateID) {
                                        main.isSelect = true
                                    }
                                })
                                main.catogary.map(main2 => {
                                    data.data[12].map(item => {
                                        if (main2.ExhProgramCategoryID == item.ExhProgramCategoryID) {
                                            main2.isSelect = true
                                        }
                                    })
                                })
                            })
                        }
                        sessionStorage.setItem("delegateShowName", data.data[0][0].AccountTypeName?.split(' ')[0])
                        this.setState({
                            programList: programList,
                            GroupDetailsList: GroupDetailsList,
                            agreeTerms: data.data[0][0].IsAgree,
                            isLoading: false
                        })
                        // }
                        this.setState({
                            agreeTerms: data.data[0][0].IsAgree,
                            isLoading: false
                        })
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }, 3000);

    }

    // get fill List dropdown  
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        this.setState({ isLoading: true })
        try {
            return new Promise((resolve, reject) => {
                this.props
                    .fill_action(actionID, exhibitionID, moduleID, keyValue, value, from)
                    .then((data) => {
                        if (data.error != 1) {
                            // ExhibitionID
                            if (actionID === primaryChapterListActionId) {
                                console.log("primaryChapterListActionId 121212", data.data)
                                async function seqnoFormat(arr) {
                                    for (var i = 0; i < arr.length; i++) {
                                        if (arr[i].seqno != '' && arr[i].seqno != null) {
                                            arr[i].ChapterName.trim()
                                            // console.log(arr[i].ChapterName)
                                            if (/^\d$/.test(arr[i].ChapterName[0])) {
                                                for (var j = 0; j < arr[i].ChapterName.length; j++) {
                                                    if (arr[i].ChapterName[j] == ' ') {
                                                        var str = arr[i].ChapterName.slice(j)
                                                        var finalName = arr[i].seqno + str
                                                        arr[i].ChapterName = finalName
                                                        // console.log("primaryChapterListActionId 121212", i, finalName)
                                                        break
                                                    }
                                                }
                                            } else {
                                                var str = arr[i].ChapterName
                                                var finalName = arr[i].seqno + ' ' + str
                                                arr[i].ChapterName = finalName
                                            }
                                        }
                                    }
                                    return
                                }

                                for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                    if (data.data['primaryChapter'][i].ChapterID == 2046) {
                                        data.data['primaryChapter'][i].ChapterName = 'TECHNICAL TEXTILE PRODUCTS & HOME TEXTILE PRODUCT'
                                    }
                                    if (data.data['primaryChapter'][i].ChapterID == 2033) {
                                        data.data['primaryChapter'].splice(i, 1)
                                    }
                                    console.log(data.data['primaryChapter'])
                                }
                                for (var i = 0; i < data.data['level2'].length; i++) {
                                    for (var j = 0; j < data.data['level2'].length - 1 - i; j++) {
                                        var seq1 = data.data['level2'][j].seqno
                                        var seq2 = data.data['level2'][j + 1].seqno
                                        if ((parseFloat(seq1) > parseFloat(seq2))) {
                                            var temp = data.data['level2'][j]
                                            data.data['level2'][j] = data.data['level2'][j + 1]
                                            data.data['level2'][j + 1] = temp;
                                        }
                                    }
                                    data.data['level2'][i].primaryChapterId = data.data['level2'][i].ParentChapterID
                                    seqnoFormat(data.data['level2'])
                                }
                                console.log(data.data['primaryChapter'])
                                for (var i = 0; i < data.data['primaryChapter'].length; i++) {
                                    for (var j = 0; j < data.data['primaryChapter'].length - 1 - i; j++) {
                                        var seq1 = data.data['primaryChapter'][j].seqno
                                        var seq2 = data.data['primaryChapter'][j + 1].seqno
                                        if ((parseFloat(seq1) > parseFloat(seq2))) {
                                            var temp = data.data['primaryChapter'][j]
                                            data.data['primaryChapter'][j] = data.data['primaryChapter'][j + 1]
                                            data.data['primaryChapter'][j + 1] = temp;
                                            // console.log(i, j, arr[j])
                                        }
                                    }
                                    if (data.data['primaryChapter'][i].seqno == null || data.data['primaryChapter'][i].seqno == undefined) {
                                        console.log(data.data['primaryChapter'][i].seqno, i)
                                    }
                                    // seqnoFormat(data.data['primaryChapter'])
                                }
                                for (var i = 0; i < data.data['level3'].length; i++) {
                                    for (var j = 0; j < data.data['level3'].length - 1 - i; j++) {

                                        var seq1 = data.data['level3'][j].seqno
                                        seq1 = seq1 != null && seq1.replaceAll('.', '')
                                        var seq2 = data.data['level3'][j + 1].seqno
                                        seq2 = seq2 != null && seq2.replaceAll('.', '')

                                        if ((parseFloat(seq1) > parseFloat(seq2))) {
                                            var temp = data.data['level3'][j]
                                            data.data['level3'][j] = data.data['level3'][j + 1]
                                            data.data['level3'][j + 1] = temp;
                                        }
                                    }
                                    for (var j = 0; j < data.data['level2'].length; j++) {
                                        if (data.data['level2'][j].ChapterID == data.data['level3'][i].ParentChapterID) {
                                            data.data['level3'][i].primaryChapterId = data.data['level2'][j].ParentChapterID
                                            break
                                        }
                                    }
                                    seqnoFormat(data.data['level3'])
                                }
                                for (var i = 0; i < data.data['level4'].length; i++) {
                                    for (var j = 0; j < data.data['level4'].length - 1 - i; j++) {
                                        var seq1 = data.data['level4'][j].seqno
                                        seq1 = seq1 != null && seq1.replaceAll('.', '')
                                        var seq2 = data.data['level4'][j + 1].seqno
                                        seq2 = seq2 != null && seq2.replaceAll('.', '')
                                        if ((parseFloat(seq1) > parseFloat(seq2))) {
                                            var temp = data.data['level4'][j]
                                            data.data['level4'][j] = data.data['level4'][j + 1]
                                            data.data['level4'][j + 1] = temp;
                                            // console.log(i, j, arr[j])
                                        }
                                    }
                                    for (var j = 0; j < data.data['level3'].length; j++) {
                                        if (data.data['level3'][j].ChapterID == data.data['level4'][i].ParentChapterID) {
                                            for (var k = 0; k < data.data['level2'].length; k++) {
                                                if (data.data['level2'][k].ChapterID == data.data['level3'][j].ParentChapterID) {
                                                    data.data['level4'][i].primaryChapterId = data.data['level2'][k].ParentChapterID
                                                    break
                                                }
                                            }
                                            break
                                        }
                                    }
                                    seqnoFormat(data.data['level4'])
                                }
                                for (var i = 0; i < data.data['level2'].length; i++) {
                                    data.data['level2'][i].isHighlight = false;
                                }
                                const level0list = data.data['level0'].map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                const primaryChapterListDatalist = data.data['primaryChapter'].map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                const level2list = data.data['level2'].map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                const level3list = data.data['level3'].map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                const level4list = data.data['level4'].map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                this.setState({
                                    primaryChapterListData: data.data['primaryChapter'] ? data.data['primaryChapter'] : [],
                                    level0: data.data['level0'] ? data.data['level0'] : [],
                                    level2: data.data['level2'] ? data.data['level2'] : [],
                                    level3: data.data['level3'] ? data.data['level3'] : [],
                                    level4: data.data['level4'] ? data.data['level4'] : [],
                                    primaryChapterListDataModal: primaryChapterListDatalist ? primaryChapterListDatalist : [],
                                    level0Modal: level0list ? level0list : [],
                                    level2Modal: level2list ? level2list : [],
                                    level3Modal: level3list ? level3list : [],
                                    level4Modal: level4list ? level4list : [],

                                })
                                // if (!isPrevious) {
                                //     this.setState({ isLoading: false, })
                                // }
                                resolve(true)
                            }
                            if (actionID === surchargeListActionId) {
                                console.log("country data", data.data)
                                this.setState({
                                    pgViewChargesFillList: data.data,
                                    //  isLoading: false,
                                })
                                // data.data.length > 0 && data.data.map(item => {
                                //     item.PaymentModuleID == 2 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
                                // })
                                resolve(true)
                            }
                            if (actionID == paymentMasterListActionId) {
                                console.log("country data", data.data)
                                // this.setState({
                                //     pgViewChargesFillList: data.data,
                                //     //  isLoading: false,
                                // })
                                data.data.length > 0 && data.data.map(item => {
                                    item.PaymentModuleID == 4 && this.setState({ isPaymentEnable: item.IsPaymentEnable })
                                })
                                resolve(true)
                            }
                            if (actionID === countryIWithCodeActionId) {
                                console.log("country data", data.data[0]['ExhibitionID'])
                                var emailArr = data.data[0].ExhMailEmail != '' && data.data[0].ExhMailEmail != null ? data.data[0].ExhMailEmail.split(",") : []
                                var mobileArr = data.data[0].ExhMailMobile != '' && data.data[0].ExhMailMobile != null ? data.data[0].ExhMailMobile.split(",") : []
                                sessionStorage.setItem("sessionExhibitionID", data.data[0]['ExhibitionID'])
                                sessionStorage.setItem("exhibitionAddress", data.data[0]['Address'])
                                sessionStorage.setItem("sessionBannerPath", data.data[0]['Banner'])
                                sessionStorage.setItem("exhibitionDateFrom", data.data[0]['ExhibitionDateFrom'])
                                sessionStorage.setItem("exhibitionDateTo", data.data[0]['ExhibitionDateTo'])
                                sessionStorage.setItem("ExhibitionCountryID", data.data[0]['ExhibitionCountryID'])
                                sessionStorage.setItem("sessionLogoPath", data.data[0]['Logo'])

                                sessionStorage.setItem("sessionExhibitionName", data.data[0]['ExhibitionName'])
                                sessionStorage.setItem("sessionExhibitionEmail", JSON.stringify(emailArr))
                                sessionStorage.setItem("sessionExhibitionMobileNo", JSON.stringify(mobileArr))
                                sessionStorage.setItem("sessionExhMailWebsite", data.data[0]['ExhMailWebsite'])
                                sessionStorage.setItem("isVisitorB2B", data.data[0]['isVisitorB2B'])
                                sessionStorage.setItem("isVisitorSeminar", data.data[0]['isVisitorSeminar'])

                                sessionStorage.setItem("ExhVisitorVisaIssueDate", data.data[0]['ExhVisitorVisaIssueDate'])
                                this.setState({
                                    isDataLoad: true,
                                    bannerPath: data.data[0]['Banner'] != null && data.data[0]['Banner']
                                })

                                // this.getFillList(countryActionId, data.data[0]['ExhibitionID'], '', '', '', '')
                                resolve(true)
                            }
                            if (actionID === exhibitionStatusActionId) {
                                console.log("exhibitionStatusActionId", data.data)
                                this.setState({
                                    isExhbitionClosed: data != null && data.data[0]['IsExhibitionClosed'] == 1 ? true : false,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            if (actionID === countryActionId) {
                                console.log("country data", data.data)
                                this.setState({
                                    countryList: data != null ? data.data : [],
                                    personalCountryList: data.data,
                                    tempPersonalCountryList: data.data,
                                    delgationCountryList: data.data,
                                    tempDelegationCountryList: data.data,
                                    passCountryList: data.data,
                                    tempPassCountryList: data.data,
                                    // isLoading: false,

                                })
                                resolve(true)
                            }
                            if (actionID === stateActionId) {
                                console.log("stateList data", data.data)
                                this.setState({
                                    stateList: data.data,
                                    tempStateList: data.data,
                                    tempGroupStateList: data.data,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            if (actionID === companyTurnOverActionId) {
                                console.log("country data", data.data)
                                this.setState({
                                    turnOverList: data.data,
                                    turnOverListModal: data.data,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            // city list
                            if (actionID === cityActionId) {
                                console.log("city data", data.data)
                                this.setState({
                                    cityList: data.data,
                                    tempCityList: data.data,
                                    tempGroupCityList: data.data,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            if (actionID === seminarInterestActionId) {
                                data.data.sort((a, b) => a.SeqNo - b.SeqNo);
                                const list = data.data.map(item => ({
                                    ...item,
                                    isSelect: false,
                                }));
                                const listModal = data.data.map(item => ({
                                    ...item,
                                    isSelect: false,
                                }));
                                console.log("Visitor Interest List 121212", data.data)
                                this.setState({
                                    seminarList: list,
                                    seminarListModal: listModal,
                                    // isLoading: false
                                })
                                // if (!isPrevious) {
                                //     this.setState({ isLoading: false, })
                                // }
                                resolve(true)
                            }
                            // pincode
                            if (actionID === pincodeActionId) {
                                console.log("pincode data", data.data)
                                this.setState({
                                    pincodeList: data.data,
                                    tempPincodeList: data.data,
                                    tempGroupPincodeList: data.data,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            if (actionID === genderActionId) {
                                console.log("genderActionId data", data.data)
                                this.setState({
                                    genderList: data.data,
                                    // tempPincodeList: data.data,
                                    // tempGroupPincodeList: data.data,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            if (actionID === GSTvalidationActionId) {
                                console.log("country data", data.data)
                                this.setState({
                                    gstValidtionList: data.data,
                                })
                                resolve(true)
                            }
                            if (actionID === industryChaptersActionId) {
                                console.log("industryChaptersActionId 121212", data.data)
                                // var list = []
                                // var listModal = []
                                const list = data.data.map(item => ({
                                    ...item,
                                    isSelect: false,
                                }));
                                const listModal = data.data.map(item => ({
                                    ...item,
                                    isSelect: false,
                                }));
                                this.setState({
                                    chapterList: list,
                                    chapterListModal: listModal,

                                })
                                // if (!isPrevious) {
                                //     this.setState({ isLoading: false, })
                                // }
                                resolve(true)
                            }
                            if (actionID === visitorTypeListActionId) {
                                console.log("Attendee Type data", data.data)

                                data.data.length > 0 && data.data.map((item) => {
                                    item.isChecked = false
                                })
                                this.setState({
                                    visitorTypeList: data.data,
                                    // isLoading: false,
                                })
                                resolve(true)
                            }
                            if (actionID === visitPurposeActionId) {
                                console.log(" Visit Purpose List data", data.data)
                                const list = data.data.map(item => ({
                                    ...item,
                                    isSelect: false,
                                    otherDetail: ""
                                }));
                                const listModal = data.data.map(item => ({
                                    ...item,
                                    isSelect: false,
                                    otherDetail: ""
                                }));
                                this.setState({
                                    visitPurposeList: list,
                                    visitPurposeListModal: listModal,
                                })
                                // if (!isPrevious) {
                                //     this.setState({ isLoading: false, })
                                // }
                                resolve(true)
                            }
                            if (actionID === visitorInterestActionId) {
                                this.setState({
                                    interestList: data.data,
                                    interestListModal: data.data,
                                })
                                // if (!isPrevious) {
                                //     this.setState({ isLoading: false, })
                                // }
                                resolve(true)
                            }
                            if (actionID === exhibitorBadgeDaysActionId) {
                                console.log("exhibitor data", data.data)
                                var DateList = []
                                // var DateListModal = []
                                // data.data.map(item => {
                                //     DateList.push(item)
                                // })
                                // data.data.map(item => {
                                //     DateListModal.push(item)
                                // })
                                data.data.map((item) => {
                                    // item.isSelect = false
                                    // item.isReadOnly = false
                                    // item.Code = item.VisitDate
                                    var mapData = {
                                        "Code": item['DateValue'],
                                        "VisitDate": item['DateValue'],
                                        "isSelect": false,
                                        "isReadOnly": false,
                                        // 'PriceINR': item['PriceINR'],
                                        // 'PriceUSD': item['PriceUSD'],
                                        // 'PromoCode': null,
                                        // 'PromoCodeDiscount': null
                                    }
                                    DateList.push(mapData)
                                    // DateListModal.push(mapData)
                                })
                                const DateListModal = DateList.map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                this.setState({
                                    daysList: DateList,
                                    daysListModal: DateListModal,
                                    // isLoading: false,
                                    isExhibitionFree: data.data[0]['isExhibitionFree'],
                                })
                                resolve(true)
                            }
                            if (actionID === B2BTimeslotActionID) {
                                // console.log(" Visit Purpose List data", data.data)
                                var B2bDates = []
                                data.data.length > 0 && data.data.map((item) => {
                                    if (!B2bDates.includes(item.B2BDate)) {
                                        B2bDates.push(item.B2BDate)
                                    }
                                })
                                var finalDateList = []

                                B2bDates.length > 0 && B2bDates.map((item) => {
                                    var obj = {}
                                    obj.date = item
                                    obj.timeSlotList = []
                                    data.data.length > 0 && data.data.map((item2) => {
                                        if (item == item2.B2BDate) {
                                            var timeobj = {}
                                            timeobj.timeslot = `${item2.B2BStartTime} To ${item2.B2BEndTime}`
                                            timeobj.IsBooked = item2.IsBooked
                                            timeobj.isSelect = false
                                            timeobj.B2BTimeSlotID = item2.B2BTimeSlotID
                                            obj.timeSlotList.push(timeobj)
                                        }
                                    })
                                    finalDateList.push(obj)
                                })

                                const finalDateListModal = finalDateList.map(item => ({
                                    ...item // Create a new object for the modal list
                                }));
                                // data.data.length > 0 && data.data.map((item) => {
                                //     item.isSelect = false
                                //     item.otherDetail = ""
                                // })
                                console.log('finalDateList', finalDateList)
                                this.setState({
                                    B2bMeetingList: finalDateList,
                                    B2bMeetingListmodal: finalDateListModal,
                                })
                                // // if (!isPrevious) {
                                // //     this.setState({ isLoading: false, })
                                // // }
                                resolve(true)
                            }
                        } else {
                            console.log(data.error, 'data.error')
                            window.location.reload()
                        }
                    }).catch((e) => {
                        window.location.reload()
                        console.log(e);
                    });
            })
        } catch (err) {
            console.log(err)
            window.location.reload()
        }
    }

    // onPrevClick(e) {
    //     e.preventDefault()
    //     const { accountId, visitorId } = this.state
    //     this.props.navigate(`/delegateAdditionalDetails`, { state: { is_previous: true } })
    // }

    onPrevClick(e) {
        e.preventDefault()
        const { accountId, visitorId } = this.state
        if (JSON.parse(sessionStorage.getItem('isLinkOpen'))) {
            this.props.navigate(`/delegateRegistration/${sessionStorage.getItem("sessionExhibitionID")}`, { state: { is_previous: true } })
        } else {
            this.props.navigate(`/delegateRegistration`, { state: { is_previous: true } })
        }
    }

    renderGroupList(list) {
        const { GroupDetailsList, countryList, showFieldList, isVisaApplied, B2bMeetingList, daysList } = this.state
        // var selectedDaysList = data.data['SelectedVisitDays'] != null ? data.data['SelectedVisitDays'] : []
        // daysList.length > 0 && daysList.map((item) => {
        //     selectedDaysList.length > 0 && selectedDaysList.map((element) => {
        //         if (element.VisitDate == item.VisitDate) {
        //             item.isSelect = true
        //         }
        //     })
        // })
        console.log(list, 'list-group ')
        return (<>
            <ul class="list-group " style={{ position: 'relative', zIndex: 1 }}>
                {
                    list.length > 0 && list.map((data, i) => (
                        <>
                            <li className="list-group-item border-0 p-0 mb-0 bg-transparent" key={Math.random()}>
                                <div className="card text-start border p-0 preview-card" style={{ borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                    <div className="card-header d-flex justify-content-between align-items-center py-2 px-3 preview-section-head" style={{ backgroundColor: "#e2e2e2", borderBottom: "1px solid #d4d4d4" }}>
                                        <h6 className="mb-0 text-dark" style={{ fontSize: "16px", fontWeight: "600", display: "flex" }}>
                                            Personal Information
                                        </h6>
                                    </div>
                                    <div className="card-body px-3 py-3 text-start">
                                        <div className="mb-3 text-start">
                                            <h6 className="mb-3 fw-bold" style={{ display: "flex", color: "#444", fontSize: "14px" }}>
                                                {data.IsCoordinator ? 'Coordinator' : data.DelegateRegistrationNo.split('/')[0] != 'DEL' ? `${data.AccountTypeName}` : `Delegate ${i}`}
                                            </h6>
                                        </div>
                                        <div className="row text-start">
                                            {/* Column 1: Personal Information */}
                                            <div className="col-md-4">
                                                <h6 className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: "0.5px" }}>PERSONAL INFORMATION</h6>
                                                <hr className="mb-3 mt-0" style={{ opacity: 0.1, width: "80%" }} />

                                                {this.showMandatoryFields(2, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>First Name</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.firstName || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(3, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Last Name</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.lastName || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(5, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Designation</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.designation || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(6, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Institute/Organisation</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.CompanyName || "-"}</span>
                                                </div>}

                                                {data.CompanyProfile != '' && data.CompanyProfile != null && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Company Profile</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.CompanyProfile || "-"}</span>
                                                </div>}
                                                {data.CompanyWebsite != '' && data.CompanyWebsite != null && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Company Website</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.CompanyWebsite || "-"}</span>
                                                </div>}
                                                {data.PersonProfile != '' && data.PersonProfile != null && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Person Profile</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.PersonProfile || "-"}</span>
                                                </div>}

                                                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && this.showMandatoryFields(37, 0) &&
                                                    // this.showMandatoryFields(6, 0) && 
                                                    <div className="mb-3">
                                                        <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Source</small>
                                                        <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Source || "-"}</span>
                                                    </div>}
                                            </div>

                                            {/* Column 2: Contact Details */}
                                            <div className="col-md-4">
                                                <h6 className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: "0.5px" }}>CONTACT DETAILS</h6>
                                                <hr className="mb-3 mt-0" style={{ opacity: 0.1, width: "80%" }} />

                                                {this.showMandatoryFields(16, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Email</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500", wordBreak: "break-all" }}>{data.PrimaryEmail || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(21, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Mobile</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.mobNo || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(22, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>WhatsApp No</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.whatsAppMobNo || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(17, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Website</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500", wordBreak: "break-all" }}>{data.Website || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(18, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Telephone</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Telephone || "-"}</span>
                                                </div>}
                                                {this.showMandatoryFields(19, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Telephone 1</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Telephone1 || "-"}</span>
                                                </div>}

                                                {data.CompanyTurnOver != '' && data.CompanyTurnOver != null && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Company Turn Over (in USD)</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.CompanyTurnOver || "-"}</span>
                                                </div>}
                                            </div>

                                            {/* Column 3: Location */}
                                            <div className="col-md-4">
                                                <h6 className="text-muted mb-3" style={{ fontSize: "12px", fontWeight: "bold", letterSpacing: "0.5px" }}>LOCATION</h6>
                                                <hr className="mb-3 mt-0" style={{ opacity: 0.1, width: "80%" }} />

                                                {this.showMandatoryFields(20, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Country</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.CountryName || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(14, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>State</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.State || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(13, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>City</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.City || "-"}</span>
                                                </div>}

                                                {this.showMandatoryFields(15, 0) && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Pincode</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.Pin || "-"}</span>
                                                </div>}


                                                {data.TotalOperationalYears != '' && data.TotalOperationalYears != null && <div className="mb-3">
                                                    <small className="text-muted d-block" style={{ fontSize: "13px", fontWeight: "500" }}>Total Years the Company Is Operational</small>
                                                    <span style={{ fontSize: "15px", color: "#222", fontWeight: "500" }}>{data.TotalOperationalYears || "-"}</span>
                                                </div>}

                                            </div>
                                        </div>
                                        {/* <div className="row mt-2">
                                        {this.showMandatoryFields(27, 0) && <div className="col-md-4">
                                            <h6>Arrival Date: {moment(data.ArrivalDate).format('Do MMM YYYY')}</h6>
                                        </div>}
                                        {this.showMandatoryFields(28, 0) && <div className="col-md-4">
                                            <h6>Departure Date:  {moment(data.DepartureDate).format('Do MMM YYYY')}</h6>
                                        </div>}
                                    </div> */}

                                        {data.PersonPhoto ?
                                            <div className="mb-1 text-left">
                                                <h6 className="mb-0" style={{ fontSize: "14px", fontWeight: "600" }}>Person Photo</h6>
                                                {(() => {
                                                    const photoSrc1 = data.PersonPhoto;
                                                    return photoSrc1 ? (
                                                        <div style={{ position: "relative", display: "inline-block" }}>
                                                            <img
                                                                src={
                                                                    (photoSrc1?.includes("base64,"))
                                                                        ? (photoSrc1)
                                                                        : BASE_URL?.split('/api')[0] +
                                                                        (photoSrc1)
                                                                }
                                                                alt="Preview"
                                                                style={{ width: "250px", height: "250px", objectFit: "contain" }}
                                                            />
                                                        </div>) : ''
                                                })()}
                                            </div>
                                            : ''
                                        }
                                    </div>
                                </div>
                                {this.showMandatoryFields(33, 0) && data.IsIntrestedForB2B &&
                                    <>
                                        <div className="containerfluid">
                                            <div className="row mt-2">
                                                <div className="col-md-12">
                                                    <div className="p-1 title-bg d-flex">
                                                        <p className="mb-0">
                                                            B2B meetings
                                                            <span className="text-red">*</span>
                                                            {/* {!isExhibitionFree && <span
                                                                                    style={{ marginLeft: '10px', cursor: 'pointer' }}
                                                                                    // style={{ textAlign: 'right', right: '20px', position: 'absolute', cursor: 'pointer' }} 
                                                                                    className="mb-0 text-danger"
                                                                                    onClick={() => this.setState({ isOpen4: true })}>
                                                                                    Visit days Charges
                                                                                </span>} */}
                                                        </p>
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1 ml-2'>{this.state.b2bErr}</span>} */}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="row">
                                                {/* {data.status && */}
                                                <div className="col-sm-12 mt-2 mb-2" >
                                                    <label className="d-flex">
                                                        <input type="checkbox" name="fav_language"
                                                            select={data.IsIntrestedForB2B} checked={data.IsIntrestedForB2B} disabled
                                                        // onChange={(e) => this.onSelectInterest(e)}
                                                        />
                                                        Interested to take part in B2B meetings
                                                    </label>
                                                    {data.IsIntrestedForB2B &&
                                                        <>
                                                            {/* {console.log(B2bMeetingList, 'B2bMeetingList', B2bMeetingListmodal)} */}
                                                            <div className="col-md-12">
                                                                <div className="table-responsive" >
                                                                    <table className="table border table-bordered mb-0 mt-1" >
                                                                        <thead>
                                                                            <tr>
                                                                                <th className="text-center" style={{ width: '100px' }}>Date</th>
                                                                                <th className="text-center" style={{ width: '180px' }}>TimeSlots</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                                data.B2BmappingList.length > 0 && data.B2BmappingList.map((item, i) => (
                                                                                    <tr key={i}>
                                                                                        <td className="text-center" >{moment(item.date).format('DD MMM YYYY')}</td>
                                                                                        <td>
                                                                                            <div className="form-row m-2">

                                                                                                {item.timeSlotList.length > 0 && item.timeSlotList.map((item2) => (
                                                                                                    <div className='col-sm-4 mt-1 mb-1'>
                                                                                                        <ToggleButton
                                                                                                            // size="sm"
                                                                                                            disabled
                                                                                                            className={`p-2 rounded-5 ${item2.IsBooked && 'text-white'} `}
                                                                                                            id={item2.B2BTimeSlotID}
                                                                                                            type="checkbox"
                                                                                                            variant={!item2.IsBooked ? "outline-primary" : "outline-secondary"}
                                                                                                            // disabled={item2.IsBooked}
                                                                                                            checked={item2.isSelect}
                                                                                                            value={item2.B2BTimeSlotID}
                                                                                                        // onClick={(e) => this.onSelect(item2.B2BTimeSlotID)}
                                                                                                        >
                                                                                                            {item2.timeslot}
                                                                                                        </ToggleButton>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            }
                                                                        </tbody>
                                                                    </table>

                                                                    <div />
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div></>
                                }
                                {data.visitdays.length > 0 && this.showMandatoryFields(34, 0) && (
                                    <div className="card text-start border p-0 preview-card" style={{ borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                        <div className="card-header d-flex justify-content-between align-items-center py-2 px-3 preview-section-head" style={{ backgroundColor: "#e2e2e2", borderBottom: "1px solid #d4d4d4" }}>
                                            <h6 className="mb-0 text-dark" style={{ fontSize: "16px", fontWeight: "600", display: "flex" }}>
                                                Date of Visit Single Day Pass / All Day Pass <span className="text-red ms-1">*</span>
                                            </h6>
                                        </div>
                                        <div className="card-body px-3 py-3 text-start">
                                            <div className="row">
                                                {data.visitdays.map((element, index) => (
                                                    <div className="col-xl-4 col-md-6" key={element.Code}>
                                                        <label className="d-flex align-items-center m-0">
                                                            <input type="checkbox" className="me-2" select={element.isSelect} checked={element.isSelect} value={element.Code} disabled={true} />
                                                            {element.VisitDate}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {data.isVisaAssistance && this.showMandatoryFields(35, 0) &&
                                    <div className="one-section mb-3">
                                        {/* <div className="containerfluid">
                                        <div className="row mt-2">
                                            <div className="col-md-12">
                                                <div className="p-1 title-bg d-flex">
                                                    <p className="mb-0">
                                                        Visa Application<span className="text-red">*</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                        {
                                            data.isVisaAssistance &&
                                            //  sessionStorage.getItem('DelegateTypeID') == 2 &&
                                            //map+all data points
                                            // data.isCoordinatorAsDelegate &&
                                            < div
                                                className="list-group-item col-md-12 m-3"
                                                id="divMsg"
                                            // style={{backgroundColor:}}
                                            >
                                                <h5>Visa Application</h5>
                                                <div className="row">
                                                    {/* <h5>{data.isCoordinator ? 'Coordinator' : `Visitor ${i}`}</h5> */}
                                                    {console.log('ppp')}
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Name as per Passport<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" disabled className="form-control" value={data.NameOnPassport} maxLength={'50'}
                                                            onChange={(e) => this.onInput(e, e.target.value, i, 'name')}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.passNameErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Applicant mobile number<span className="text-red">*</span>
                                                        </label>
                                                        <div className="phone-input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control phone-code mt-2" autoComplete="off" placeholder="ISD"
                                                                // placeholder="ISD"
                                                                value={data.PreApplicantMobileNo}
                                                                disabled
                                                                // onChange={(e) => this.setState({ preApplicantMobNo: e.target.value })}
                                                                maxLength={'10'}
                                                            />
                                                            <input type="number" disabled className="form-control phone-no" value={data.ApplicantMobileNo}
                                                                maxLength={'10'} onInput={(e) => this.maxLengthCheck(e, 10)}
                                                                onPaste={(e) => this.handlePaste(e)}
                                                                onKeyDown={(e) => this.preventMinus(e)} onWheel={(e) => e.target.blur()}
                                                            />
                                                        </div>
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantMobNoErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Applicant email id<span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" className="form-control" value={data.ApplicantEmailID} maxLength={'50'}
                                                            disabled
                                                        // onChange={(e) => this.setState({ applicantEmail: e.target.value, applicantEmailErr: "" })}
                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.applicantEmailErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Passport No
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <input type="text" disabled className="form-control" value={data.PassportNo} maxLength={'10'}
                                                        // onChange={(e) => this.setState({ passNo: e.target.value, passNoErr: "" })}
                                                        // onChange={(e) => this.onInput(e, e.target.value, i, 'passno')}

                                                        />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.PassportNo}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Passport issue Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={data.PassportIssueDate} disabled
                                                            onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDate')}
                                                            // onChange={(date) =>
                                                            //     this.setState({
                                                            //         passDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                            //         passDateErr: ""
                                                            //     })}
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            maxDate={data.PassportExpiryDate}
                                                            dropdownMode="select"
                                                            placeholderText="Passport Issued Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.passDateErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">Passport Expiry Date
                                                            <span className="text-red">*</span>
                                                        </label>
                                                        <DatePicker selected={data.PassportExpiryDate} disabled
                                                            onChange={(date) => this.onInput(date, new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())), i, 'passDateEx')}
                                                            // onChange={(date) =>
                                                            //     this.setState({
                                                            //         passExipryDate: new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())),
                                                            //         passExipryDateErr: ""
                                                            //     })}
                                                            dateFormat={"dd/MM/yyyy"} className="form-control"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            minDate={data.PassportIssueDate}
                                                            dropdownMode="select"
                                                            placeholderText="Passport Expiry Date"
                                                            dayClassName={() => "example-datepicker-day-class"}
                                                            popperClassName="example-datepicker-class" />
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.passExipryDateErr}</span>} */}
                                                    </div>
                                                    <div className="col-xl-3">
                                                        <label className="mt-3">
                                                            Passport issuing Country<span className="text-red">*</span>
                                                        </label>
                                                        {/* <input type="text" className="form-control" value={data.PassportIssuingCountryID} disabled
                                                        // onChange={(e) => this.onInput(e, e, i, 'passCountry')}
                                                        

                                                        /> */}
                                                        <select className="form-control" value={data.PassportIssuingCountryID}
                                                            // onChange={(e) => this.onCountrySelect(e, 2)}
                                                            disabled
                                                        >
                                                            <option>Select Your Country</option>
                                                            {
                                                                countryList.length > 0 && countryList.map((item) => (
                                                                    <option key={item.Code} value={item.Code} >{item.Description}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        {/* {data.isDisplayPassCountryList && this.renderPassCountryList(i)} */}
                                                        {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.passCountryErr}</span>} */}
                                                    </div>
                                                    {!(data.isPassportFilePresent) &&
                                                        <div className="col-xl-5">
                                                            <label className="mt-3">
                                                                Passport Front Page (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            <form action="/action_page.php" style={{ display: "inline-flex" }}>
                                                                <input
                                                                    // type="file" id="passportFile" name="filename"
                                                                    //     accept=".jpg, .jpeg, .png, .pdf" maxLength={"50"}
                                                                    //     onChange={e => this.onFilePick(e, e.target.files, 1)}
                                                                    type="file"
                                                                    id={`path${i}`}
                                                                    disabled
                                                                    className="image-upload"
                                                                    accept=".jpg, .jpeg, .png"
                                                                // onChange={e => this.onInput(e, e.target.files, i, 'passImg')}
                                                                />
                                                                {/* {<span className='text-danger text-start text-left d-block mt-1'>{data.passportFileErr}</span>} */}
                                                                {/* {
                                        data.passportFile != "" &&
                                        <i class="fa fa-times text-danger img-can"
                                            onClick={() => this.onCrossClick(1, i)}
                                        ></i>
                                    } */}
                                                            </form>
                                                        </div>
                                                    }
                                                    {
                                                        data.isVisaApplied && data.passportFilePath != "" && data.passportFilePath != null && data.isPassportFilePresent &&
                                                        <div className="col-xl-5">
                                                            <label className="mt-3">
                                                                Passport Front Page File
                                                                <span className="text-red">*</span>
                                                            </label>
                                                            {(() => {
                                                                const photoSrc = data.passportFilePath;
                                                                return photoSrc ? (
                                                                    <div style={{ position: "relative", display: "inline-block" }}>
                                                                        <img
                                                                            src={
                                                                                (photoSrc?.includes("base64,"))
                                                                                    ? (photoSrc)
                                                                                    : BASE_URL?.split('/api')[0] +
                                                                                    (photoSrc)
                                                                            }
                                                                            alt="Preview"
                                                                            style={{ width: "250px", height: "250px", objectFit: "contain" }}
                                                                        />
                                                                    </div>) : ''
                                                            })()}
                                                            {/* <div style={{
                                                                border: '1px solid #ccc',
                                                                padding: '10px',

                                                                // display: 'inline-flex',
                                                                alignItems: 'center',
                                                                marginTop: '10px',
                                                                // marginLeft: '12px',
                                                                maxWidth: '300px'
                                                            }}>
                                                                <span style={{ marginRight: '10px' }}
                                                                >{data.passportFileName}</span>
                                                            </div> */}
                                                        </div>
                                                    }
                                                </div>
                                            </div>

                                        }
                                    </div>}
                                {this.showMandatoryFields(30, 0) && data.industrySegmentList.length > 0 &&
                                    <div className="one-section mt-0">
                                        <div className="card text-start border p-0 preview-card" style={{ borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                            <div className="card-header d-flex justify-content-between align-items-center py-2 px-3 preview-section-head" style={{ backgroundColor: "#e2e2e2", borderBottom: "1px solid #d4d4d4" }}>
                                                <h6 className="mb-0 text-dark" style={{ fontSize: "16px", fontWeight: "600", display: "flex" }}>
                                                    Industry Segment <span className="text-red ms-1">*</span>
                                                </h6>
                                            </div>
                                            <div className="card-body px-3 py-3 text-start">
                                                <div className="row mt-1">
                                                    {data.industrySegmentList.map((element, index) => (
                                                        <div className="col-sm-3" key={element.IndustrySegmentID}>
                                                            <label className="d-flex align-items-start m-0" style={{ fontSize: '13px' }}>
                                                                <input type="checkbox" className="me-2 mt-1" select={element.isSelect} checked={element.isSelect} value={element.IndustrySegmentID} disabled />
                                                                {element['Industrial Segment']}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.showMandatoryFields(31, 0) && data.purposeOfVisitList.length > 0 &&
                                    <div className="one-section mt-0">
                                        <div className="card text-start border p-0 preview-card" style={{ borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                            <div className="card-header d-flex justify-content-between align-items-center py-2 px-3 preview-section-head" style={{ backgroundColor: "#e2e2e2", borderBottom: "1px solid #d4d4d4" }}>
                                                <h6 className="mb-0 text-dark" style={{ fontSize: "16px", fontWeight: "600", display: "flex" }}>
                                                    Purpose of Visit <span className="text-red ms-1">*</span>
                                                </h6>
                                            </div>
                                            <div className="card-body px-3 py-3 text-start">
                                                <div className="row mt-1">
                                                    {data.purposeOfVisitList.map((element, index) => (
                                                        <div className="col-sm-3" key={element.PurposeofVisitID || index}>
                                                            <label className="d-flex align-items-start m-0" style={{ fontSize: '13px' }}>
                                                                <input type="checkbox" className="me-2 mt-1" select={element.IsSelect} checked={element.IsSelect} value={element.PurposeofVisitID} disabled />
                                                                {element['PurposeofVisitName']}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {this.showMandatoryFields(32, 0) && data.chaptersList.length > 0 &&
                                    <div className="one-section mt-0">
                                        <div className="card text-start border p-0 preview-card" style={{ borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                            <div className="card-header d-flex justify-content-between align-items-center py-2 px-3 preview-section-head" style={{ backgroundColor: "#e2e2e2", borderBottom: "1px solid #d4d4d4" }}>
                                                <h6 className="mb-0 text-dark" style={{ fontSize: "16px", fontWeight: "600", display: "flex" }}>
                                                    Products <span className="text-red ms-1">*</span>
                                                </h6>
                                            </div>
                                            <div className="card-body px-3 py-3 text-start">
                                                <p className="mb-3" style={{ fontSize: 15 }}>
                                                    <strong>Selected Products</strong>
                                                </p>
                                                <div className="ps-2">
                                                    {data.chaptersList.length > 0 ? data.chaptersList.map((element, index) => (
                                                        <p key={index} className="mb-1">{formatChapterName(element.ChapterName)}</p>
                                                    )) : <p>No Results</p>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {data.seminarList.length > 0 && this.showMandatoryFields(36, 0) &&
                                    <div className="one-section mt-0">
                                        <div className="card text-start border p-0 preview-card" style={{ borderRadius: "4px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
                                            <div className="card-header d-flex justify-content-between align-items-center py-2 px-3 preview-section-head" style={{ backgroundColor: "#e2e2e2", borderBottom: "1px solid #d4d4d4" }}>
                                                <h6 className="mb-0 text-dark" style={{ fontSize: "16px", fontWeight: "600", display: "flex" }}>
                                                    Seminar
                                                </h6>
                                            </div>
                                            <div className="card-body px-3 py-3 text-start">
                                                <div className="table-responsive">
                                                    <table className="table border table-bordered mb-0 mt-1">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '180px' }}>Date & Time</th>
                                                                <th style={{ width: '680px' }}>Session Name</th>
                                                                <th style={{ width: '120px' }} className="text-center"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data.seminarList.length > 0 && data.seminarList.map((item3) => (
                                                                this.state.seminarList.length > 0 && this.state.seminarList.map((item2) => (
                                                                    item2.SeminarID == item3.SeminarID &&
                                                                    <tr key={Math.random()}>
                                                                        <td className={item2.ParentSeminarID != 0 ? null : "fw-bold"}>{item2.DateTime}</td>
                                                                        <td className={item2.ParentSeminarID != 0 ? null : "fw-bold"}>{item2.SessionName}</td>
                                                                        <td className="text-center">
                                                                            {item2.ParentSeminarID != 0 &&
                                                                                item2.SeminarTypeID == 1 ? <input type="checkbox"
                                                                                    value={item2.isSelect}
                                                                                    checked={item2.isSelect}
                                                                                    disabled
                                                                                    onChange={(e) => this.onCheckedSeminar(e, item2.SeminarID)}
                                                                            /> : item2.SeminarTypeID == 2 ? <span>
                                                                                <strong>Request for Invite</strong>
                                                                            </span> :
                                                                                <input type="checkbox"
                                                                                    value={item2.isSelect}
                                                                                    checked={item2.isSelect}
                                                                                    disabled
                                                                                    onChange={(e) => this.onCheckedSeminar(e, item2.SeminarID)}
                                                                                />
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                            </li>

                            {/* <hr className="m-1" /> */}

                        </>

                    ))
                }
            </ul >
        </>
        )
    }

    handleSubmit(e) {
        e.preventDefault()
        const { isLoading, arrivalDate, isPaymentEnable, arrivalDateErr, totalCharges, agreeTerms, departureDate, departureDateErr } = this.state
        this.setState({ isLoading: true })
        /// Setting data in session storage For Insert Next
        this.props.delegatePreviewSubmit_action(sessionStorage.getItem('DelegateTypeID'), null, null, totalCharges, isPaymentEnable, 1)
            .then((data) => {
                this.setState({ isLoading: false, PIID: data.data.length > 0 && data.data[7] != undefined && data.data[7].length > 0 && data.data[7][0] != undefined && data.data[7][0].ProformaInvoiceID != undefined ? data.data[7][0].ProformaInvoiceID : '' }, () => {
                    // toastSuccess("Visitor Submitted Successfully")
                    if (totalCharges > 0 && isPaymentEnable) {
                        this.navToPayment()
                    } else {
                        this.props.navigate('/delegateThanks', {
                            state: {
                                // ExhVisitorID: data.data[0]['ExhVisitorID'],
                                // countryID: countryId
                            }
                        })
                    }
                })

            })
    }

    getFieldList(typeId) {
        const { attendeeList, industryChapterList, GroupDetailsList, primaryChapterListData, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal,
            level2, level3, level4, seminarInterestList, seminarInterestListModal, countryList,
            stateList, turnOverList,
            cityList,
            pincodeList,
            genderList,
            gstValidtionList,
            chapterList, chapterListModal,
            visitorTypeList,
            visitPurposeList, visitPurposeListModal,
            interestList,
            daysList, daysListModal, B2bMeetingListmodal,
            B2bMeetingList } = this.state
        // this.setState({isLoading: true })
        this.props.getDelegateFirldList_action(typeId)
            .then((data) => {
                if (data.error != 1) {
                    var showFieldListArr = []
                    if (data.data[1] != null) {
                        if (data.data[1].length > 0) {
                            for (var i = 0; i < data.data[1].length; i++) {
                                var obj = {
                                    'id': data.data[1][i].FieldID, 'mandatory': data.data[1][i].IsMandatory, 'name': data.data[1][i].FieldName
                                }
                                showFieldListArr.push(obj)
                            }
                        }
                    }
                    console.log('data.data', showFieldListArr)
                    sessionStorage.setItem('showFieldList', JSON.stringify(showFieldListArr))
                    this.setState({
                        showFieldList: showFieldListArr
                    })
                }
            })
    }

    showMandatoryFields(FieldID, mode) {
        const { showFieldList } = this.state
        var isFieldAvailable = false
        for (var i = 0; i < showFieldList.length; i++) {
            // console.log(showFieldList[i], FieldID)
            if (showFieldList[i].id == FieldID) {
                isFieldAvailable = true
                if (mode == 0) {
                    return true
                } else if (mode == 1) {
                    return showFieldList[i].name
                } else if (mode == 2) {
                    if (showFieldList[i].mandatory) {
                        return true
                    } else {
                        return false
                    }
                }
            }
        }
        if (!isFieldAvailable) {
            return false
        }
    }

    togglePGCharges(mode) {
        const { scripts, GroupDetailsList, countryId, isForeignDelegatePop } = this.state
        if (mode != 2) {
            if (sessionStorage.getItem("DelegateTypeID") == 10) {
                if (sessionStorage.getItem("countryId") != 91) {
                    this.setState({ isForeignDelegatePop: true })
                    return
                }
            } else {
                for (var i = 0; i < GroupDetailsList.length; i++) {
                    if (GroupDetailsList[i].CountryName.trim().toLowerCase() != 'india') {
                        this.setState({ isForeignDelegatePop: true })
                        return
                    }
                }
            }
        }
        if (sessionStorage.getItem("countryId") == 91) {
            this.setState({ pgViewChargesModal: !this.state.pgViewChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        } else {
            this.setState({ pgViewAddChargesModal: !this.state.pgViewAddChargesModal, isSurchargeForceOpen: mode != 1 ? false : this.state.isSurchargeForceOpen });
        }
    }

    navToPayment() {
        const { parkingCharges, countryId, remark, visitorCharges, isCarParking, promoCodeDiscount, toPay, totalCharges } = this.state
        // const totalCharges = visitorCharges + (isCarParking ? parkingCharges : 0) - promoCodeDiscount

        var cancel_url = `${BASE_URL}/delegate/paymentResponse`
        var redirect_url = `${BASE_URL}/delegate/paymentResponse`;//need to ask to redirect

        var request = {
            order_id: `${JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID}`,
            currency: `${sessionStorage.getItem('countryId') == 91 ? 'INR' : 'USD'}`,
            amount: `${totalCharges}`,
            redirect_url: `${redirect_url}`,
            cancel_url: `${redirect_url}`,
            merchant_param1: `${'1'}`,
            language: `EN`
        }

        var mapData = {
            'orderParams': request
        }

        // this.props.payment_action(mapData)
        //     .then((data) => {
        //         if (data != null) {
        //             console.log("payment response : ", data)
        //             this.setState({ encPayload: data.data })
        //             setTimeout(() => {
        //                 console.log("submit form", this.submitfrm)
        //                 this.submitfrm.current.submit()
        //                 // this.props.navigate('/payment', { state: { encPayload: this.state.encPayload, } })
        //             }, 1000);
        //         } else {
        //             this.setState({ isLoading: false })
        //             toast.error('There is some problem. Please try again later!', {
        //                 theme: 'colored',
        //                 autoClose: 3000,
        //                 hideProgressBar: true,
        //             })
        //         }
        //     })
        //     .catch((err) => {
        //         console.log(err)
        //     })
        var moreInfo = null
        this.setState({ isLoading: true })

        this.props.sendPaymentForm_action(sessionStorage.getItem("sessionExhibitionID"),
            JSON.parse(sessionStorage.getItem('DelegateTypeID')) == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationIDs,
            sessionStorage.getItem('countryId') == 91 ? totalCharges : this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2),
            sessionStorage.getItem('countryId') == 91 ? 'INR' : this.state.isPaidByUSD ? 'USD' : 'INR', [{ ProformaInvoiceID: this.state.PIID }], 'delegateRegistration', moreInfo, remark, JSON.parse(sessionStorage.getItem('DelegateTypeID')) == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID, JSON.parse(sessionStorage.getItem('DelegateTypeID')) == 10 ? JSON.parse(sessionStorage.getItem("DelegateDataSS")).DelegateRegistrationNos.split(',')[0] : JSON.parse(sessionStorage.getItem("DelegateDataSS")).DelegateRegistrationNo, sessionStorage.getItem('countryId') == 91 ? false : this.state.isPaidByUSD)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    if (data != null) {
                        console.log("payment response : ", data)

                        // this.setState({ encPayload: data.data }, () => {
                        //     this.submitfrm.current.submit()
                        // })
                        this.setState({ paymentLink: data.data }, () => {
                            // this.submitfrm.current.submit()
                            // window.open(data.data, '_blank')
                            window.location.replace(data.data)

                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError('There is some problem. Please try again later!')
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    selectProgram(flag, id) {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        if (flag == 1) {
            var beforeValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramID == id) {
                    if (programList[i].isSelect) {
                        beforeValue = true
                        break
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramID == id) {
                    if (beforeValue) {
                        programList[i].isSelect = false
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = false
                        }
                    } else {
                        programList[i].isSelect = true
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
        } if (flag == 2) {
            var beforeValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == id) {
                    if (programList[i].isSelect) {
                        beforeValue = true
                        break
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == id) {
                    if (beforeValue) {
                        programList[i].isSelect = false
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = false
                        }
                    } else {
                        programList[i].isSelect = true
                        for (var j = 0; j < programList[i].catogary.length; j++) {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
        } if (flag == 3) {
            var beforeValue = false
            var DateId = ''
            var DateValue = false
            console.log(id)
            for (var i = 0; i < programList.length; i++) {
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    if (programList[i].catogary[j].ExhProgramCategoryID == id) {
                        DateId = programList[i].ExhProgramDateID
                        if (programList[i].catogary[j].isSelect) {
                            beforeValue = true
                            break
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                for (var j = 0; j < programList[i].catogary.length; j++) {
                    if (programList[i].catogary[j].ExhProgramCategoryID == id) {
                        if (beforeValue) {
                            programList[i].catogary[j].isSelect = false
                        } else {
                            programList[i].catogary[j].isSelect = true
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == DateId) {
                    for (var j = 0; j < programList[i].catogary.length; j++) {
                        if (programList[i].catogary[j].isSelect) {
                            DateValue = true
                            break
                        }
                    }
                }
            }
            for (var i = 0; i < programList.length; i++) {
                if (programList[i].ExhProgramDateID == DateId) {
                    if (DateValue) {
                        programList[i].isSelect = true

                    } else {
                        programList[i].isSelect = false
                    }
                }
            }
        }
        this.setState({ programList: programList })
    }

    checkSelectedProgram(id) {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        var beforeValue = false
        for (var i = 0; i < programList.length; i++) {
            if (programList[i].ExhProgramID == id) {
                if (programList[i].isSelect) {
                    beforeValue = true
                    break
                }
            }
        }
        return beforeValue
    }

    checkselectallprogram() {
        const { isLoading, isOpenDropDownState, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename, delegateUUID,
            PersonPhotoModal, PersonPhotoDataModal, PersonPhotoNameModal, PersonPhotoTypeModal, PersonPhotoPreviewModal, PersonProfileModalErr, PersonPhotoModalErr, agreeTerms, agreeTermsErr, programList, GroupDetailsList, delegateIndex } = this.state
        var beforeValue = true
        var uniqueArr = []
        for (var i = 0; i < programList.length; i++) {
            if (!uniqueArr.includes(programList[i].ExhProgramID)) {
                uniqueArr.push(programList[i].ExhProgramID)
            }
            // if (programList[i].isSelect) {
            //     if (programList[i].isSelect) {
            //         beforeValue = true
            //         break
            //     }
            // }
        }
        for (var i = 0; i < programList.length; i++) {
            for (var j = 0; j < uniqueArr.length; j++) {
                if (uniqueArr[j] == programList[i].ExhProgramID) {
                    if (!programList[i].isSelect) {
                        beforeValue = false
                    }
                    break
                }
            }
        }
        console.log(uniqueArr, 'programList')
        return beforeValue
    }

    render() {
        const { isLoading, programList, agreeTerms, isOpen4, isExhbitionClosed, isDataLoad, isOtherPreName, otherName, firstName, firstNameErr, prename,
            middleName, lastName, lastNameErr, genderList, countryIdErr, seminarList, countryId, countryList, preMobNo, preWhatsAppMobNo, stateList, tempStateList, cityList, tempCityList, pincodeList, tempPincodeList, gender, genderErr, designation, designationErr, institute, instituteErr, IECCode, IECCodeErr, Address1, Address2, Address3, Address1Err, pincode, isDisplayPincodeList, pincodeErr, regState, regStateErr, isDisplayStateList, city, cityErr, email, emailErr, isDisplayCityList, website, companywebsite, companywebsiteModal, mobNo, mobNoErr, whatsAppMobNo, whatsAppMobNoErr, isSameAsMobNo, telNo, preTelNo, tel1No, preTel1No, compInfoGstNo, compInfoGstNoErr, gstValidtionList, visitPurposeList, visitPurposeErr, stateId, compInfoPanNoErr, compInfoPanNo, other, isOtherOpen, chapterList, companyProfile, isModalEdit, isOpen, totalYears, turnOverList, turnOverId, turnOverErr, totalYearsErr, companyProfileErr, isOtherPreNameModal, otherNameModal, firstNameModal, firstNameErrModal, prenameModal, middleNameModal, lastNameModal, lastNameErrModal, countryIdErrModal, countryIdModal, countryListModal, genderErrModal, preMobNoModal, preWhatsAppMobNoModal, stateListModal, tempStateListModal, cityListModal, tempCityListModal, pincodeListModal, tempPincodeListModal, genderListModal, genderModal, designationModal, designationErrModal, instituteModal, instituteErrModal, IECCodeModal, IECCodeErrModal, Address1Modal, Address2Modal, Address3Modal, Address1ErrModal, pincodeModal, isDisplayPincodeListModal, pincodeErrModal, regStateModal, regStateErrModal, isDisplayStateListModal, cityModal, cityErrModal, isDisplayCityListModal, emailModal, emailErrModal, mobNoModal, mobNoErrModal, whatsAppMobNoModal, whatsAppMobNoErrModal, isSameAsMobNoModal, telNoModal, preTelNoModal, tel1NoModal, preTel1NoModal, compInfoGstNoModal, compInfoGstNoErrModal, stateIdModal, compInfoPanNoErrModal,
            compInfoPanNoModal, chapterErrModal, chapterListModal, isOtherOpenModal, otherModal, seminarListModal, companyProfileModal, websiteModal, totalYearsModal, turnOverListModal, turnOverIdModal, interestList, turnOverErrModal, totalYearsErrModal, isInterestTwo, companyProfileErrModal, visitPurposeListModal, daysList, daysListModal, sExhibitionFree, visitPurposeErrModal, isFirst, arrivalDate, arrivalDateErr, isCoordinatorAsDelegate, IsCoordinator, departureDate, departureDateErr, arrivalDateModal, arrivalDateErrModal, departureDateModal, departureDateErrModal, interestListModal, isInterestTwoModal, daysErr, daysErrModal, isOpen3, delegateCharges, pgViewAddChargesModal, pgViewChargesFillList, pgViewChargesModal, toShow, totalCharges, additionalChargesUSD, additionalChargesUSDper,
            paymentDatesList, primaryChapterListData, level0, level2, ChapterHallErrModal, level3, level4, ChapterHallErr, primaryChapterListDataModal, level0Modal, level2Modal, level3Modal, level4Modal, B2bMeetingList, B2bMeetingListmodal, needVisaAssistance, passName, passNameErr, applicantMobNo, applicantMobNoErr, preApplicantMobNo, applicantEmail, applicantEmailErr, passNo, passNoErr, passDate, passDateErr, passExipryDate, passExipryDateErr, passCountryErr, passCountry, isPassportFilePresent, isVisaApplied, passportFileErr, passportFile, passPortFileName,
            needVisaAssistanceModal, passNameModal, passNameErrModal, applicantMobNoModal, applicantMobNoErrModal, preApplicantMobNoModal, applicantEmailModal, applicantEmailErrModal, passNoModal, passNoErrModal, passDateModal, passDateErrModal, passExipryDateModal, passExipryDateErrModal, passCountryErrModal, passCountryModal, isPassportFilePresentModal, isVisaAppliedModal, GroupDetailsList, passportFileErrModal, passportFileModal, passPortFileNameModal } = this.state
        // const allArray = [...primaryChapterListData, ...level2, ...level3, ...level4]
        // const filerArray = allArray.filter((data) => data.IsCheckbox && data.isSelect)
        // const allArrayModal = [...primaryChapterListDataModal, ...level2Modal, ...level3Modal, ...level4Modal]
        // const filerArrayModal = allArrayModal.filter((data) => data.IsCheckbox && data.isSelect)

        const toInputUppercase = e => {
            e.target.value = ("" + e.target.value).toUpperCase();
        };
        var finalArr = []
        for (var i = 0; i < this.state.GroupDetailsList.length; i++) {
            var obj = { ...this.state.GroupDetailsList[i] }
            finalArr.push(obj)
        }
        console.log('GroupDetailsList', GroupDetailsList, delegateCharges)
        var paymentDatesListDel = []
        if (finalArr.length > 0) {
            var noOfVisitor = 1
            for (var i = 0; i < finalArr.length; i++) {
                var obj = { name: `${finalArr[i].firstName} ${finalArr[i].lastName}`, displayDates: [] }
                // !finalArr[i].isCoordinator && noOfVisitor++
                for (var j = 0; j < finalArr[i].visitdays.length; j++) {
                    // var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
                    obj.displayDates.push(finalArr[i].visitdays[j].VisitDate)
                }
                obj.displayDates.length > 0 && obj.displayDates.join(', ')
                paymentDatesListDel.push(obj)
            }
        } else {
            for (var i = 0; i < daysList.length; i++) {
                // var obj = { ...this.state.visitorGroupList[i], ...this.state.GroupDetailsList[i] }
                if (daysList[i].isSelect) {
                    paymentDatesListDel.push(daysList[i].VisitDate)
                }
                // finalArr.push(obj)
            }
        }
        const showProgramTable = programList.some(obj => obj.isSelect == true)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>

                ) : (
                    null
                )}
                <ToastContainer />
                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <HeaderWithLogo />}
                {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && <AdminDrawer />}
                {/* {console.log(!isLinkOpen)} */}
                <div className={!JSON.parse(sessionStorage.getItem('isLinkOpen')) && 'main-content app-content with-dr-container'} style={{ marginTop: '5rem' }}>
                    < VisitorHeader />
                    <div
                        className="main-content app-content mt-0"
                        style={{ marginInlineStart: 0 }}
                    >
                        {!isLoading ?
                            <div className="side-app px-3 px-md-4">
                                <div className="container-fluid p-0">
                                    {/* Grey title bar fixed under the header, same as the registration form */}
                                    <div className="row m-0">
                                        <div className="breadcrumb-scroll-fixed p-0 delegate-reg-bar">
                                            {/* Same side padding as the page (px-3 px-md-4), so the title lines up with the cards */}
                                            <h6 className="mb-0 py-2 px-3 px-md-4 text-white">{sessionStorage.getItem('delegateShowName')} Registration Form Preview</h6>
                                        </div>
                                    </div>
                                </div>
                                {
                                    // sessionStorage.getItem('DelegateTypeID') == 2 &&
                                    <div className="combine-section">
                                        <div className="needs-validation after-step mt-1 delegate-reg-content" style={{ marginTop: 115 }}>
                                            <div id="Menu1">
                                                <div id="section-1">
                                                    <div>
                                                        {this.renderGroupList(GroupDetailsList)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="needs-validation after-step mt-1">
                                    <div id="Menu1">
                                        <div id="section-1">
                                            {this.state.note.length > 0 && <div className="one-section mt-2">
                                                <div className="col-xl-6 mt-2">
                                                    <p className="fw-bold m-0">Note:</p>
                                                    {this.state.note.length > 0 && this.state.note.map((item, i) => (
                                                        <p className="ms-2">{i + 1}	{item}</p>
                                                    ))}
                                                    <label className="d-flex" style={{ marginLeft: '3rem' }} >
                                                        {/* lll */}
                                                    </label>
                                                </div>
                                            </div>}
                                            {this.showMandatoryFields(29, 0) && <div className="one-section">
                                                <div className="col-xl-12">
                                                    <div className="form-row mt-0 mb-3">
                                                        <div>
                                                            <label className="d-flex align-items-center m-0" >
                                                                <input type="checkbox" className="me-2" style={{ height: 20, width: 20 }}
                                                                    // name={data.ExhRegistrationNotesId}
                                                                    value={agreeTerms}
                                                                    checked={agreeTerms}
                                                                    disabled
                                                                    onClick={e => this.setState({ agreeTerms: !agreeTerms })}
                                                                />
                                                                I agree all the rules & regulations of delegation process & Exhibition Guidelines of India ITME Society
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {!JSON.parse(sessionStorage.getItem("isExhibitionFree")) && sessionStorage.getItem("AccountTypeID") == 10 && this.state.isPaymentEnable && <div className="one-section">
                                                <div className="containerfluid">
                                                    <div className="row mt-2">
                                                        <div className="col-md-12">
                                                            <div className="p-1 title-bg">
                                                                <p className="mb-0">Payment Details <span className="text-danger">(convenience fees will be applicable at payment stage.)</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <div className="col-xl-3 mb-4 mt-2" style={{ float: "right" }}>
                                                <div className="row d-flex" >
                                                    <input type="text" className="form-control" />
                                                    <button class="btn btn-primary" >
                                                        <a className=""  >
                                                            Apply</a>
                                                    </button>
                                                </div>

                                            </div> */}
                                                {<div className="one-section">

                                                    <div className="container-fluid">
                                                        {/* Promo Code Section */}
                                                        {/* <div className="row">
                                                            <div className="col-md-4 mt-2">
                                                                <label>Promo Code</label>
                                                                <div className="d-flex">
                                                                    <input
                                                                        type="text"
                                                                        className="form-control rounded-0 me-2"
                                                                        disabled={isPromoApply}
                                                                        value={promoCode}
                                                                        onChange={(e) => this.setState({ promoCode: e.target.value.trim() })}
                                                                    />
                                                                    {isPromoApply ? (
                                                                        <button
                                                                            className="btn btn-gray"
                                                                            onClick={() => this.onCancelPromo()}
                                                                        >
                                                                            Back
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            className="btn btn-aqua"
                                                                            onClick={() => this.onApplyPromo()}
                                                                        >
                                                                            Apply
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div> */}

                                                        {/* Charges Grid Section */}
                                                        <div className="row mt-4">
                                                            <div className="col-md-4">
                                                                <div className="row mb-3">
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h5 className="mb-0">Delegate Registration Charges</h5>
                                                                        <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{delegateCharges}</h5>
                                                                    </div>
                                                                    <div className="row" style={{ paddingRight: 0, textAlign: 'left' }}>
                                                                        {console.log('paymentDatesList', paymentDatesListDel[0])}
                                                                        {/* {paymentDatesList.length > 0 && paymentDatesList.map((item, i) => (
                                                                    <div className="d-flex justify-content-between" style={{ padding: 0 }}>
                                                                        <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                            <>{item2}
                                                                                {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                                &nbsp;
                                                                            </>))})</p>
                                                                    </div>
                                                                ))} */}
                                                                        <strong onClick={() => this.setState({ isOpen4: true })} className="text-primary" style={{ cursor: 'pointer' }}>(Click here to view Visit Days)</strong>
                                                                    </div>
                                                                </div>
                                                                {/* {promoCodeDiscount != 0 && (
                                                                    <div className="row mb-2">
                                                                        <div className="d-flex justify-content-between mb-2">
                                                                            <h5 className="mb-0">Promo Code Discount({discountpercent}%)</h5>
                                                                            <h5 className="mb-0 text-danger">-{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.promoCodeDiscount}</h5>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                
                                                                {/* {isParkingAvailable && isCarParking != 0 && parkingCharges != 0 && (
                                                                <div className="row mb-2">
                                                                    <div className="col-6">
                                                                        <h6>Parking Charges</h6>
                                                                    </div>
                                                                    <div className="col-6 text-end">
                                                                        <h6>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{isCarParking ? parkingCharges : 0}</h6>
                                                                    </div>
                                                                </div>
                                                            )} */}
                                                                {
                                                                    <div className="row mb-2">
                                                                        <div className="d-flex justify-content-between mb-2">
                                                                            <h5 className="mb-0">Total Taxable </h5>
                                                                            <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.totaltaxable}</h5>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                {this.state.CGST != 0 && (
                                                                    <div className="row mb-2">
                                                                        <div className="d-flex justify-content-between mb-2">
                                                                            <h5 className="mb-0">CGST</h5>
                                                                            <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.CGST}</h5>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {this.state.SGST != 0 && (
                                                                    <div className="row mb-2">
                                                                        <div className="d-flex justify-content-between mb-2">
                                                                            <h5 className="mb-0">SGST</h5>
                                                                            <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.SGST}</h5>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {this.state.IGST != 0 && (
                                                                    <div className="row mb-2">
                                                                        <div className="d-flex justify-content-between mb-2">
                                                                            <h5 className="mb-0">IGST</h5>
                                                                            <h5 className="mb-0">{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.IGST}</h5>
                                                                        </div>
                                                                    </div>
                                                                )}


                                                                <div className="row mt-n2">
                                                                    <div className="col-md-12">
                                                                        <hr />
                                                                    </div>
                                                                </div>
                                                                <div className="row  " >
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>Total Charges</h6>
                                                                        <h6 className="mb-0" style={{ fontSize: '1.5rem' }}>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{this.state.totalCharges}</h6>
                                                                    </div>
                                                                </div>

                                                                {/* <div className="row border-top pt-2 mt-2 align-items-start">
                                                                
                                                                <div className="col-6">
                                                                    <h5>Total Charges</h5>
                                                                </div>
                                                                <div className="col-6">
                                                                    <h5>{sessionStorage.getItem("countryId") == 91 ? '₹' : '$'}{totalCharges}</h5>
                                                                </div>
                                                            </div> */}
                                                            </div>
                                                        </div>

                                                        {/* Remark Section */}
                                                        {/* <div className="row">
                                                        <div className="col-md-4 mt-3">
                                                            <label>Remark</label>
                                                            <textarea
                                                                className="form-control"
                                                                value={this.state.remark}
                                                                onChange={(e) => this.setState({ remark: e.target.value })}
                                                            />
                                                        </div>
                                                    </div> */}
                                                    </div>
                                                </div>
                                                }

                                            </div>}
                                            {/* Program Selection Table */}
                                            {!JSON.parse(sessionStorage.getItem('isLinkOpen')) && sessionStorage.getItem('AccountTypeID') != 10 && sessionStorage.getItem('AccountTypeID') != null && (
                                                <div className="mt-4 m-2">
                                                    <h6 className="mb-1 mt-2 fw-semibold mb-3"><i className="fa fa-list-alt me-2"></i>Program</h6>
                                                    <div className="table-responsive border rounded bg-white shadow-sm">
                                                        <table className="table table-bordered table-hover align-middle mb-0">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th className="text-center" style={{ width: '50px' }}>
                                                                        <input type="checkbox" className=" mt-0"
                                                                            disabled
                                                                        // checked={this.checkselectallprogram()}
                                                                        // onChange={() => {
                                                                        //     for (var i = 0; i < programList.length; i++) {
                                                                        //         programList[i].isSelect = true
                                                                        //         for (var j = 0; j < programList[i].category.length; j++) {
                                                                        //             programList[i].category[j].isSelect = true
                                                                        //         }
                                                                        //     }
                                                                        //     this.setState({ programList: programList })
                                                                        // }}
                                                                        // checked={this.state.master_all || false}
                                                                        // onChange={(e) => {
                                                                        //     const checked = e.target.checked;
                                                                        //     const newState = {
                                                                        //         master_all: checked,
                                                                        //         p1_all: checked,
                                                                        //         p2_all: checked, p2_0: checked, p2_1: checked, p2_2: checked,
                                                                        //         p3_all: checked
                                                                        //     };
                                                                        //     ['p3_0_cat_0', 'p3_0_cat_1', 'p3_0_cat_2', 'p3_0_cat_3'].forEach(k => newState[k] = checked);
                                                                        //     this.setState(newState);
                                                                        // }}
                                                                        />
                                                                    </th>
                                                                    <th style={{ width: '220px' }}>Program Name </th>
                                                                    <th style={{ width: '220px' }}>Date & time</th>
                                                                    <th>Category</th>
                                                                    <th className="text-center" style={{ width: '100px' }}>Location</th>
                                                                    <th className="text-center" style={{ width: '100px' }}>Invitation Card</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {showProgramTable && programList.length > 0 && programList.map(item => (
                                                                    item.isSelect && <tr>
                                                                        {item.toShow && <>
                                                                            <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0">
                                                                                <input type="checkbox" className=" mt-0"
                                                                                    disabled
                                                                                    checked={this.checkSelectedProgram(item.ExhProgramID)}
                                                                                    onChange={(e) => this.selectProgram(1, item.ExhProgramID)} />
                                                                            </td>
                                                                            <td rowSpan={item.rowspan} className="fw-semibold align-middle bg-white border-bottom-0 text-dark">{item.ProgramName}</td>
                                                                        </>}
                                                                        <td>
                                                                            <div className="d-flex align-items-center">
                                                                                {
                                                                                    item.rowspan > 1 &&
                                                                                    <input type="checkbox" className=" me-2 mt-0"
                                                                                        checked={item.isSelect}
                                                                                        disabled
                                                                                        onChange={(e) => this.selectProgram(2, item.ExhProgramDateID)}
                                                                                    //  onChange={(e) => this.setState({ [`p2_${i}`]: e.target.checked, p2_all: false, master_all: false })}
                                                                                    />}
                                                                                <span style={{ fontSize: '14px' }}>{item.Date}</span>
                                                                                {<span style={{ fontSize: '14px' }} className="ms-2 text-muted"><i className="fa fa-clock-o me-1"></i>{item.StartTime} - {item.EndTime}</span>}
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className="d-flex flex-wrap gap-3">
                                                                                {item.catogary.length > 0 ?
                                                                                    <div className="d-flex flex-row align-items-center gap-3 flex-nowrap">{
                                                                                        item.catogary.map(element => (
                                                                                            <label className="mb-0 d-flex flex-row align-items-center" style={{ whiteSpace: 'nowrap', cursor: 'pointer' }}>
                                                                                                {item.catogary.length > 1 && <input type="checkbox" className="me-2 mt-0" style={{ width: '16px', height: '16px' }}
                                                                                                    checked={element.isSelect}
                                                                                                    disabled
                                                                                                    onChange={(e) => this.selectProgram(3, element.ExhProgramCategoryID)}
                                                                                                // onChange={(e) => this.setState({ [`${d.rowKey}_cat_${cIdx}`]: e.target.checked, p3_all: false, master_all: false })}
                                                                                                />}
                                                                                                <span className="text-dark">{element.CategoryName}</span>
                                                                                            </label>
                                                                                        ))
                                                                                    }</div> :
                                                                                    <div className="d-flex flex-wrap gap-3">
                                                                                        <span style={{ fontSize: '14px', fontWeight: 'bold' }}>-</span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        {item.toShow && (
                                                                            <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0 text-dark">{item.Location}</td>
                                                                        )}
                                                                        {item.toShow && (
                                                                            <td rowSpan={item.rowspan} className="text-center align-middle bg-white border-bottom-0 text-dark">
                                                                                {item.DocumentPath != '' &&
                                                                                    <a
                                                                                        href={item.DocumentPath}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        <span style={{ marginRight: '10px' }}
                                                                                        >{item.DocumentName}</span>
                                                                                    </a>}
                                                                            </td>
                                                                        )}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            )}
                                            <div className="main-container m-3">
                                                {/* Previous / Submit fixed to the bottom of the screen. Rendered straight
                                                    into <body> (portal) so no parent container can stop it staying fixed;
                                                    starts after the sidebar when the logged-in drawer is shown. */}
                                                {createPortal(
                                                <div className={`d-flex justify-content-end gap-2 sticky-actions delegate-preview-actions${!JSON.parse(sessionStorage.getItem('isLinkOpen')) ? ' with-sidebar' : ''}`}>
                                                    <button className="btn btn-outline-secondary rounded-3"
                                                        onClick={(e) => this.onPrevClick(e)}>
                                                        {/* <a style={{ padding: "4px 25px" }} > */}
                                                        Previous
                                                        {/* </a> */}
                                                    </button>
                                                    {/* <a
                                                className="btn btn-success rounded-0"
                                                style={{ padding: "4px 25px" }}
                                                type="submit"
                                                onClick={(e) => this.onSubmit(e)}
                                            >
                                                Submit
                                            </a> */}
                                                    <button className="btn btn-aqua text-white rounded-3 d-block"
                                                        // onClick={() => this.handleSubmit()}
                                                        onClick={(e) => sessionStorage.getItem("AccountTypeID") == 10 && this.state.isPaymentEnable ? this.togglePGCharges(1) : this.handleSubmit(e)}
                                                    >
                                                        {/* <a style={{ padding: "4px 25px" }} > */}
                                                        Submit
                                                        {/* </a> */}
                                                    </button>

                                                </div>, document.body)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> : ''
                        }
                    </div>
                </div>
                <Modal
                    isOpen={pgViewChargesModal}
                    onRequestClose={() => this.setState({ pgViewChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-success text-center fw-bold w-100">
                                    Bank Charges
                                </h4>
                            </div>
                            <div className="row m-3" >
                                <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mg-b-0">
                                        <thead>
                                            <tr>
                                                <th>Payment Mode</th>
                                                <th>Bank Charges</th>
                                            </tr>
                                        </thead>
                                        <tbody id="myTable">
                                            {this.state.pgViewChargesFillList.length > 0 ? (
                                                this.state.pgViewChargesFillList.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className={data.isParent ? 'fw-bold' : ""}>{data.Description}</td>
                                                        <td>{data.Value}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td colSpan={6}>No Records Found...</td>
                                                    </tr>
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1 col-3">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.handleSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                                        value={encPayload} />
                                                                    <input type="hidden" name="access_code" id="access_code"
                                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal
                    isOpen={pgViewAddChargesModal}
                    onRequestClose={() => this.setState({ pgViewAddChargesModal: false })}
                    style={{
                        content: {
                            top: "300px",
                            // maxHeight: "calc(100vh - 220px)",
                        }
                    }}
                >
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '120px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header p-3">
                                <h4 className="mb-0 pt-2 text-white text-center fw-bold w-100">
                                    Additional Charges
                                </h4>
                            </div>
                            <div className="row mb-3" >
                                <div className="containerfluid m-0  px-3 ">
                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="p-1 title-bg d-flex ps-3">
                                                <p className="mb-0">
                                                    Choose Payment Currency<span className="text-red">*</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row ms-3" >
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={this.state.isPaidByUSD}
                                                checked={this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: true, toShow: totalCharges })}
                                            />
                                            Pay in USD ($)
                                        </label>
                                    </div>
                                    <div className="col-sm-4 mt-3" >
                                        <label className="d-flex">
                                            <input type="radio" name="paidBy" value={!this.state.isPaidByUSD}
                                                checked={!this.state.isPaidByUSD}
                                                // onChange={e => this.setState({ attendeeType: "Business Visitor" })} 
                                                onChange={(e) => this.setState({ isPaidByUSD: false, toShow: (totalCharges * this.state.conversionRate).toFixed(2) })}
                                            />
                                            Pay in INR (₹)
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="row m-3" >
                                {/* <p className='mt-2 text-danger'><strong>Please note that bank charges alongwith GST as per the below table will be applicable as per selected mode of payment in the next step </strong></p> */}
                                {/* <>“”</> */}
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Delegate Registration Charges</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.toShow}</h5>
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="d-flex justify-content-between mb-2">
                                        <h5 className="mb-0">Additional charges ({this.state.additionalChargesUSDper}%)</h5>
                                        <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? (this.state.additionalChargesUSD) : ((this.state.additionalChargesUSDper / 100) * this.state.toShow).toFixed(2)}</h5>
                                    </div>
                                </div>
                                {this.state.IGST != 0 && (
                                    <div className="row mb-2">
                                        <div className="d-flex justify-content-between mb-2">
                                            <h5 className="mb-0">Total Payable</h5>
                                            <h5 className="mb-0">{this.state.isPaidByUSD ? '$' : '₹'}{this.state.isPaidByUSD ? parseFloat(this.state.additionalChargesUSD) + parseFloat(this.state.toShow) : ((1 + (this.state.additionalChargesUSDper / 100)) * this.state.toShow).toFixed(2)}</h5>
                                        </div>
                                    </div>
                                )}
                                <p className='mt-2 '><strong>Kindly note that an additional {this.state.additionalChargesUSDper}% charge towards currency conversion will be applicable at the time of final payment as you proceed to the payment gateway.</strong></p>
                            </div>
                            <div className="modal-footer p-2 d-flex justify-content-end">
                                {/* {this.state.isSurchargeForceOpen && <div className=" mt-1 col-3"> */}
                                {true && <div className=" mt-1">
                                    <div style={{ float: 'right' }} className="mt-1 mb-1 mr-3 ">
                                        <form onSubmit={(e) => this.handleSubmit(e)} ref={this.submitfrm} id="nonseamless" method="post" name="redirect"
                                            // action={paymentPortalLink}
                                            className="pay-btn-form"
                                            action={this.state.paymentLink}

                                        >

                                            {/* <input type="hidden" id="encRequest" name="encRequest"
                                                                        value={encPayload} />
                                                                    <input type="hidden" name="access_code" id="access_code"
                                                                        value={paymentAccessCode} /> */}
                                            <button type="btn" class="btn btn-aqua">
                                                I agree and proceed to pay

                                            </button>
                                        </form>
                                    </div>
                                </div>}
                                <button
                                    className="btn btn-danger rounded-1"
                                    onClick={() => this.togglePGCharges(2)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.isForeignDelegatePop} >
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title modal_title_text text-Primary"></h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <strong>
                                        Payments can currently be made only using Visa, Master Card, and RuPay cards issued by non-Indian banks.                                    </strong>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-aqua"
                                        onClick={() => {
                                            this.togglePGCharges(2)
                                            this.setState({ isForeignDelegatePop: false })
                                        }
                                        }
                                    >Ok</button>
                                    <button type="button" className="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isForeignDelegatePop: false })}
                                    >Close</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal >
                <Modal isOpen={this.state.isOpen4} onRequestClose={() => this.setState({ isOpen4: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content visit-days">
                            <div class="modal-header p-2">
                                <h5 class="modal-title">Visit Days</h5>
                                <button type="button " class="close pop-close" data-dismiss="modal" onClick={() => this.setState({ isOpen4: false })} ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center" >
                                                        Name
                                                    </th>
                                                    <th className="text-center">Visit Days</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paymentDatesListDel.length > 0 ? paymentDatesListDel.map((item, index) => (
                                                        <tr key={Math.random()}>
                                                            <td className="text-center">{item.name}</td>
                                                            <td className="text-center">{item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                <>{item2}
                                                                    {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                    &nbsp;
                                                                </>
                                                            ))}</td>
                                                            {/* <p className="col-md-9"><strong>{item.name}:</strong> ({item != undefined && item.displayDates != undefined && item.displayDates.length > 0 && item.displayDates.map((item2, i2) => (
                                                                                <>{item2}
                                                                                    {item.displayDates != undefined ? i2 != item.displayDates.length - 1 ? ',' : '' : ''}
                                                                                    &nbsp;
                                                                                </>))})</p> */}

                                                        </tr>
                                                    )) : <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" onClick={() => this.setState({ isOpen4: false })}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <style>
                    {
                        `.accordion label:hover,
                        .accordion label:focus {
                         background: none;
                        }`
                    }
                </style>
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, combineVisitorRegistrationDetail_action, visitorRegistrationUpdate_action, payment_action, sendPaymentForm_action, getExhibitionProgramMaster_action,
    deleteVisaDoc_action, getVisitorRegistrationCredentials_action, getDrawerDetails_action, getVisitorPreviewDetails_action, getDelegateFirldList_action,
    visitorPreviewSubmit_action, getDelegatePreviewDetails_action, delegatePreviewSubmit_action, getExhNoteDetails_action,
})(Delegate_Preview))